import { reportMessages } from "~/features/treatment-report/i18n";

const messages = {
  "consents.title": "Уважаемый доктор",
  "consents.intro": "Для продолжения работы в личном кабинете ознакомьтесь с <policy>Политикой обработки персональных данных</policy> и отметьте своё согласие ниже.",
  "consents.personal": "Я даю согласие на <document>обработку персональных данных</document>",
  "consents.marketing": "Я даю согласие на <document>получение рекламно-информационной рассылки</document>",
  "consents.footnote": "Отмечая согласия, я подтверждаю, что ознакомился(-ась) и принимаю условия соответствующих документов, указанных по ссылкам.",
  "consents.personalRequired": 'Пожалуйста, отметьте обязательное поле "Согласие на обработку персональных данных".',
  "consents.continue": "Продолжить",
  "consents.saving": "Сохранение…",
  "consents.loading": "Загрузка…",
  "consents.loadError": "Не удалось проверить согласия. Повторите попытку.",
  "consents.saveError": "Не удалось сохранить согласия. Повторите попытку. Ваш выбор сохранён в этом окне.",

  ...reportMessages.ru,
  "pat.plan.report": "Посмотреть отчёт",
  // General
  "not.selected": "Не выбрано",
  None: "Не указано",

  None_V2: "Не указано",
  NA: "-",
  "table.search": "Поиск",
  "table.status": "Выберите статус",
  "table.clear": "Очистить",
  "button.all": "Все",
  "table.from": "С",
  "table.to": "До",
  "button.save_changes": "Сохранить изменения",
  "general.payment.show": "Показать платежи",
  "general.payment.close": "Скрыть платежи",
  "general.retry": "Повторить",
  "bool.true": "Да",
  "bool.false": "Нет",
  "word.and": "и",
  "select.option": "Выбрать",
  date: "Дата",
  millimetre: "мм",
  requiredField: "обязательные поля",
  "doctor.fullname": "ФИО",
  "doctor.manager": "Менеджер",
  "doctor.profile.info": "Информация о профиле",
  "doctor.fio.popup.title": "Уважаемый доктор,",
  "doctor.fio.popup.message": "Редактирование этих данных недоступно. Для их изменения, пожалуйста, напишите на почту {email}",
  "deep_cbct.included.title": "Уважаемый доктор,",
  "deep_cbct.included.message": "Услуга «Глубокий анализ КТ» включена в выбранный курс.",
  "not.found": "Информация не найдена",
  "click.to.copy": "Нажмите для копирования",
  next: "Следующая",
  previous: "Предыдущая",
  cancel: "Выйти без сохранения",
  fifty: "50",
  hundred: "100",
  "two.hundred": "200",
  here: "здесь",
  page: " ",
  loading: "Загрузка...",
  search: "Поиск",
  "search.clear": "Очистить поиск",
  "error_boundary.title": "Ошибка",
  "error_boundary.message": "Что-то пошло не так",
  "error_boundary.message_1": "Приносим извинения за доставленные неудобства.",
  "error_boundary.message_2": "Попробуйте перезагрузить страницу или повторить попытку позже",
  "error_boundary.reset": "Попробовать еще раз",
  learn_more: "Подробнее",
  scroll_to_top: "Пролистать наверх",
  profile_menu: "Меню профиля",
  "alert.close": "Закрыть",
  "telegram_id.required": "Это поле обязательно к заполнению при подписке на Telegram уведомления",
  "email.incorrect": "Неверный формат адреса электронной почты",
  care_support: "Служба заботы",
  "care_support.call": "Позвонить",
  "care_support.write": "Написать в мессенджере",
  "care_support.dear.doctor": "Уважаемый доктор!",
  "care_support.description.1": "Служба заботы оперативно ответит на Ваши вопросы.",
  "care_support.description.2": "Пожалуйста, выберите удобный способ для связи:",

  E_CONNECTION_FAILED: "Ошибка соединения с сервисом",

  // login page
  "login.header": "Войдите в кабинет",
  "login.login": "Логин",
  "login.password": "Пароль",
  "login.show_password": "Показать пароль",
  "login.enter": "Войти",
  "login.forgot": "Забыли пароль ?",
  "login.forgot_cta": "Восстановить пароль",
  E_INVALID_LOGIN: "Неверные данные авторизации",
  // password reminder
  "reminder.forgot": "Восстановление пароля",
  "reminder.email": "Введите логин или email и получите письмо со ссылкой для восстановления пароля",
  "reminder.placeholder": "Email",
  "reminder.placeholder.login": "Логин или Email",
  "reminder.back": "Назад",
  "reminder.submit": "Восстановить",
  "reminder.mail_send": "Ссылка для восстановления отправлена на Вашу почту. ",
  "reminder.link": "Перейти на страницу логина.",

  "redesign.auth.email.placeholder": "Введите Email",
  "redesign.auth.password.placeholder": "Введите пароль",
  "redesign.auth.login.placeholder": "Введите логин или email",
  "redesign.auth.recovery.hint": "Введите логин или email и получите письмо со ссылкой для восстановления пароля",
  "redesign.auth.policy": "Политика конфиденциальности",
  "redesign.auth.contacts": "Контакты",

  "restore_password.success": "Пароль установлен. ",
  "restore_password.success_link": "Перейти на страницу логина.",
  "restore_password.fail": "Ссылка для восстановления недействительна. Пожалуйста начните процедуру восстановления пароля заново. ",
  "restore_password.fail_link": "Восстановить пароль.",
  "reminder.payment": " ",
  "reminder.payment.card": " ",
  "reminder.payment.invoice": " ",
  "reminder.my.payments": " ",

  //tooltips
  tooltip_shipment: "Здесь можно отслеживать Ваши доставки",
  tooltip_payments: "Здесь все Ваши платежи",
  tooltip_payment: "",
  tooltip_notifications: "Здесь все Ваши уведомления",
  tooltip_3d_plan_approval_date: "Капы будут доставлены Вам в течении 15 дней от даты утверждения 3D плана",
  tooltip_precise_first_comment: "Первый комментарий 3D Precise - {labelTitle} ",
  tooltip_precise_last_comment: "Последний комментарий 3D Precise - {labelTitle}",
  "required.fields.tooltip": "Все поля, отмеченные звездочкой, являются обязательными.",
  "course.type.tooltip": "Ознакомиться с таблицей “Выбор курса” можно в разделе ",
  "course.type.tooltip.sec": "(выбор курса зависит от длительности лечения и необходимых движений).",
  "tooltip.chart": "инструкции",
  "upload.photos.tooltip": "Высококачественные изображения имеют решающее значение для точности плана лечения",
  "upload.photos.manual.tooltip": " ",
  "cbct.upload.tooltip": " ",
  "elastics.tooltip": "Не являются обязательными при работе с системой 3D Smile для большинства движений. Подробнее в разделе ",
  "tooltip.correction.btn.title": " ",
  "tooltip.correction.btn.payment.status": " ",
  "tooltip.correction.btn.warranty.date": " ",
  "tooltip.correction.btn.error": " ",
  "tooltip.corrcetion.btn.support": " ",
  "tooltip.correction.btn.no.course": " ",
  "tooltip.retainers": " ",
  "tooltip.support": " ",
  "tooltip.click.approve": "Перейти к утверждению 3D Плана",

  // Manager Info
  "manager_info.your_manager": "Ваш Менеджер 3D Smile",

  // Left menu
  "left.menu.header": "Личный кабинет",
  "left.menu.patients": "Пациенты",
  "left.menu.add_patient": "Добавить пациента",
  "left.menu.shipments": "Мои доставки",
  "left.menu.my_payments": "Мои платежи",
  "left.menu.chat": "Чат",
  "left.menu.best_case": "Лучшие случаи",
  "left.menu.library": "Библиотека клинических случаев",

  // Top menu
  "top.menu.profile": "Мой профиль",
  "top.menu.documents": "Мои документы",
  "top.menu.my_practices": "Мои клиники",
  "top.menu.add_practices": "Добавить клинику",
  "top.menu.logout": "Выйти",

  // Patient table header
  "pat_table.block_head": "Пациенты",
  "pat_table_tasks.block_head": "Текущие задачи",
  "pat_table.id": "ID",
  "pat_table.name": "ФИО пациента",
  "pat_table.delivered": "Этапов доставлено",
  "pat_table.received": "Оплачено",
  "pat_table.payments": "Оплаты",
  "pat_table.tot_payment": "Сумма оплаты",
  "pat_table.status": "Статус пациента",
  "pat_table.of": "из",
  "pat_table.total": "Итого",
  "pat_table.services": "Услуги",
  "pat_table_tasks.block_payments": "Платежи",
  "pat_table.block_banners": "Новости",
  "pat_table.patients.not_found": "Пациенты не найдены",

  // Clinics table header
  "clin_table.header": "Мои клиники",
  "clin_table.name": "Название",
  "clin_table.address": "Адрес",
  "clin_table.phone": "Номер телефона",
  "clin_table.email": "Email",
  "clin_table.contacts": "Контакты",
  // Clinic view/edit
  "clin_view.header": "ИНФОРМАЦИЯ О КЛИНИКЕ",
  "clin_view.edit.header": "РЕДАКТИРОВАТЬ КЛИНИКУ",
  "clin_view.name": "Клиника",
  "clin_view.address": "Адрес клиники",
  "clin_view.zip": "Почтовый индекс",
  "clin_view.phone": "Номер телефона клиники",
  "clin_view.email": "Email клиники",
  "clin_view.contacts": "Контактные данные",
  "clin_view.add.header": "Добавить клинику",
  "clin_view.name.placeholder": "Название",
  "clin_view.address.placeholder": "Адрес клиники",
  "clin_view.zip.placeholder": "Почтовый индекс",
  "clin_view.phone.placeholder": "Номер телефона клиники",
  "clin_view.logistic_phone.placeholder": "Номер телефона для службы доставки (не более 15 символов)",
  "clin_view.logistic_contact.placeholder": "Контактное лицо для связи со службой доставки (не более 35 символов)",
  "clin_view.logistic_phone": "Номер телефона для службы доставки",
  "clin_view.logistic_contact": "Контактное лицо для связи со службой доставки",
  "clin_view.email.placeholder": "Email клиники",
  "clin_view.contacts.placeholder": "С кем связываться по счетам и договорам...",
  "clin_view.add.button": "Добавить клинику",
  "clin_view.confirm": "Вы действительно хотите отвязать клинику?",
  "clin_view.schedule.schedule": "График работы",
  "clin_view.schedule.monday": "Понедельник",
  "clin_view.schedule.tuesday": "Вторник",
  "clin_view.schedule.wednesday": "Среда",
  "clin_view.schedule.thursday": "Четверг",
  "clin_view.schedule.friday": "Пятница",
  "clin_view.schedule.saturday": "Суббота",
  "clin_view.schedule.sunday": "Воскресенье",
  "clin_view.schedule.from": "с",
  "clin_view.schedule.to": "до",
  "clin_view.address.line.1": "Адрес",
  "clin_view.address.line.2": "Дом",
  "clin_view.address.line.3": "Город",
  "clin_view.address.not.more.then.35": " ",
  "clin_view.address.line.1.placeholder": "Улица (не более 35 символов)",
  "clin_view.address.line.2.placeholder": "Дом / строение / корпус / … (не больше 35 символов)",
  "clin_view.address.line.3.placeholder": "Город / страна / … (не более 35 символов)",
  "clin_view.detach": "Отвязать клинику",
  "clin_view.delivery.contacts": "Контакты по вопросам доставки",
  "clin_view.administrative.contacts": "Контакты по административным вопросам",

  "clin_view.error.35.symbols": "Поле должно содержать не более 35 символов",
  "clin_view.error.phone": "Неверный номер телефона",
  "clin_view.error.email": "Неверный формат адреса электронной почты",
  "clin_view.error.index": "Неверный формат индекса",
  "clin_view.error.logistic.phone": "Номер телефона должен состоять только из цифр и содержать не более 15 символов",
  "clin_view.error.logistic.contact": "Поле должно содержать не более 35 символов",
  clinics_not_found: "Клиники не найдены",

  // Right blocks patient page
  "pat.block.not_found": "Пациент не найден",
  "pat.block.right.header": "Пациент",
  "pat.block.right.id": "ID",
  "pat.block.right.name": "ФИО",
  "pat.block.right.instructions": "Дата создания заявки",
  "pat.block.right.plan_approval": "Дата утверждения 3D плана",
  "pat.block.right.aligners.eta": "Дата доставки ",
  "pat.block.right.additional.eta": "Дата доставки дубликатов ",
  "pat.block.right.retainers.eta": "Дата доставки ретейнеров ",
  "pat.block.right.delivered": "Этапов доставлено",
  "pat.block.right.correction": "Коррекция",
  "pat.block.right.additional_course": "Дополнительный комплект",
  "pat.block.right.additional": "Дополнительные услуги",
  "pat.block.right.general.treatment": "Основной курс",
  "pat.block.right.start_date": "Дата начала работ",
  "pat.block.right.plan_date": "3D-план ожидается",
  "pat.block.right.caps_date": "Отправка кап ожидается",
  "pat.block.right.warranty_end_date": "Дата окончания гарантии",
  "pat.block.status.header": "СТАТУС ПАЦИЕНТА",
  "pat.block.deliveries.header": "ДОСТАВКА",
  "pat.block.impression.delivery.header": "ОТПРАВКА СЛЕПКОВ",
  "pat.block.impression.delivery.all": "смотреть все отправления",
  "pat.block.deliveries.waybills": "Трекинг номер",
  "pat.shipments.tracking_number": "Трекинг номер",
  "pat.block.deliveries.not_found": "Доставки не найдены",
  "pat.block.shipments.not_found": "Отправления не найдены",
  "pat.shipments.eta": " ",
  "pat.shipments.header": "Мои доставки",
  "pat.shipments.description": "Здесь Вы можете отслеживать доставку элайнеров",
  "pat.shipments.selected.date": "Просмотреть с выбранной даты",
  "notify.shipments.error": "Ошибка при попытке получения отправлений",
  "pat.deliveries.button.noWaybills": "Накладные не найдены",
  "pat.block.status.status": "Статус",
  "pat.block.payment.header": "СТАТУС ОПЛАТЫ",
  "pat.block.payment.status": "Статус оплаты",
  "pat.block.payment.received": "Оплачено",
  "pat.block.payment.total": "Сумма оплаты",
  "pat.block.payment.currency": "руб.",
  "pat.block.payment.currency.curr": "руб.",

  "pat.block.payment.payments": "Курс",
  "pat.block.payment.extras": "Дополнительные услуги",
  "pat.block.payment.pay.all": "Оплатить оставшуюся сумму целиком",
  "pat.block.payment.pay.next": "Оплатить сумму",
  "pat.deliveries.button.callACourier": "Вызвать курьера",
  "pat.deliveries.button.callACourierByPhone": "Вызвать курьера по телефону",
  "pat.deliveries.button.callCourier.confirmation": "Подтвердить вызов курьера по телефону",
  "pat.deliveries.button.getWaybill": "Получить накладную",
  "pat.deliveries.button.getNewWaybill": "Получить новую накладную",
  "pat.deliveries.button.cancel": "Отменить",
  "pat.block.deliveries.estimated.pickup_date": "Дата приезда курьера",
  "pat.block.deliveries.current.pickups": "Текущее отправление",
  "pat.block.deliveries.see.waybill": "(распечатать накладную)",
  "pat.block.deliveries.aligner.delivery": "Трекинг номер (доставка кап)",
  "pat.block.deliveries.aligner.all": "все доставки",
  "pat.block.deliveries.type": "Тип",
  "pat.block.deliveries.type.laboratory": "Отправка слепков",
  "pat.block.deliveries.type.clinic": "Доставка кап",
  "pat.block.deliveries.shipment.date": "Дата отправления",
  "pat.block.deliveries.shipments.aligners": "Доставка кап",
  "pat.block.deliveries.deliveries.impressions": "Отправка слепков",
  "pat.block.deliveries.ups.site.track": "Проверить статус отправления",
  "pat.deliveries.contact.to.manager": "Отправление через ЛК невозможно. Неверно заполнены данные клиники. Обратитесь к менеджеру.",
  "pat.deliveries.error.E_INVALID_FROM": "Неверно заполнена информация о клинике",
  "pat.deliveries.error.E_UNHANDLED_ERROR": "Сервис временно недоступен",
  "pat.deliveries.error.E_SERVICE_UNAVAILABLE": "Сервис временно недоступен",
  "pat.payments.amount.to.pay": "Сумма к оплате",
  "pat.payments.buttons.pay": "Перейти к оплате",
  "pat.payments.buttons.submit": "Подтвердить",
  "pat.payments.online.payment": "Онлайн оплата",
  "pat.payments.you.will.be.redirected": "Сейчас вы будете перенаправлены на форму оплаты",
  "pat.payments.course.paid": "Оплата завершена успешно",
  "pat.payments.course.paid.error": "При проведении платежа произошла ошибка",
  "pat.payments.course.pay.course": "Оплата",
  "pat.payments.course.status.error": "Что-то пошло не так во время загрузки статуса платежа",
  "pat.payments.course.status.canceled": "Платеж был отменен",
  "pat.payments.course.status.pending": "Платеж cоздан и ожидает оплаты",
  "pat.payments.course.status.not_found": "Платеж не найден",
  "pat.payments.payment_status.goto": "Перейти к пациенту",

  //Right blocks next step status
  FIRST_3D_PLAN: "Ожидается 3D план",
  NEXT_3D_PLAN: "Ожидается 3D план",
  FIRST_SHIPMENT: "Отправка ожидается",
  NEXT_SHIPMENT: "Следующая отправка",
  NEXT_SHIPMENT_PAYMENT_EXPECTED: "Ожидание оплаты",
  // Patient view-page-only blocks
  "pat.comment.header": "ДОБАВЛЕНИЕ КОММЕНТАРИЯ",
  "pat.comment.title": "Комментарии ",
  "pat.comment.placeholder": "Комментарий...",
  "pat.comment.button": "Добавить комментарий",
  "pat.comments.hide": " ",
  "pat.comments.show": " ",
  "pat.plan.header": "3D ПЛАН",
  "pat.plan.button": "Cмотреть 3D план",
  "pat.plan.link": "Ссылка для пациента",
  "pat.plan.copy_link": "Скопировать ссылку",
  "pat.view.header": "КАРТА ПАЦИЕНТА",
  "pat.status.corr_stage": "Номер этапа:",
  "pat.status.button.correction": "Заказать коррекцию",
  "pat.status.button.additional_course": "Заказать дополнительный комплект",
  "pat.status.button.correction.new": "Заказать коррекцию (Новая форма)",
  "pat.status.button.retainers": "Заказать ретенционные капы",
  "pat.status.button.power_cap": "Заказать силовую капу",
  "pat.status.button.aligners.additional": "Заказать дубликаты кап",
  "pat.status.button.end": "Завершить лечение",
  "pat.status.button.end.confirm": "Завершить",
  "pat.status.button.end.description": "Вы уверены, что хотите завершить лечение пациента",
  "pat.status.button.confirm": "Подтверждение",
  "pat.question.button": "Задать вопрос клиническому эксперту",
  "pat.question.modal.title": "Вопрос клиническому эксперту",
  "pat.question.modal.restricted.sym": 'Нельзя использовать следующие символы "<" ">" ',
  "pat.retainers.page.header": "Ретенционные капы",
  "pat.power_cap.page.header": "Силовая капа",
  "pat.power_cap.block.header": "Силовые капы",
  "pat.power_cap.comment": "Диагноз / Клиническое состояние / Какой результат вы хотите получить?",
  "pat.power_cap.arches_select": "Выберите зубные дуги, на которые планируется изготовление силовых кап",
  "pat.power_cap.linked": "Заявка {id}",
  "pat.power_cap.buttons.submit": "Отправить в работу",
  "pat.power_cap.ship_with_retainers": "Отправить вместе с заказанными ретенционными капами",
  "pat.power_cap.order_retainers": "Заказать ретенционные капы и отправить вместе с силовой капой",
  "pat.power_cap.ships_with_retainers": "Отправка вместе с ретенционными капами",
  "pat.power_cap.in_production_hint": "Силовая капа по этому пациенту уже в работе. Новую можно заказать, когда текущая будет готова.",
  RETAINERS_COMMENT: " ",
  "pat.additional.aligners.page.header": "Дубликаты кап",
  "pat.comment.rework.header": "Пожалуйста, не забудьте оставить комментарий",
  "pat.payments.dear.doctor": "Уважаемый доктор, ",
  "pat.payments.thanks": "Спасибо ",
  "pat.payments.payment": "за оплату!",
  "pat.payments.invoice": " ",
  "pat.empty.comment": "Пожалуйста, введите комментарий",
  "notify.ok": "Ok",
  "notify.done": "Готово",
  "pat.additional.aligners.add.stage": "Добавить этап",
  "pat.additional.aligners.required.fields": "Заполните обязательные поля",
  "pat.additional.aligners.required.fields.remove.stage": "Заполните обязательные поля или удалите дополнительный этап",

  // Status names
  S_UNFILLED_CASE: "Недозаполненная заявка",
  S_INSTRUCTIONS_PROCESSING: "Заявка обрабатывается",
  S_RETAKE_IMPRESSIONS: "Ожидание информации",
  S_WAITING_FOR_A_PAYMENT: "Ожидание оплаты",
  S_3D_SCANNING: "Сканирование",
  S_3D_PLAN_MODELING: "Моделирование 3D плана",
  S_3D_PLAN_APPROVAL: "Утвердите 3D план",
  S_3D_PLAN_MODELS_BUILDING: "Лечение: печать кап",
  S_PRODUCTION_PRINTING: "Лечение: печать кап",
  S_PRODUCTION_MOLDING: "Лечение: формовка кап",
  S_PRODUCTION_MARKING: "Лечение: маркировка кап",
  S_PRODUCTION_ALLOCATING: "Лечение: изготовление кап",
  S_PRODUCTION_FABRICATING: "Лечение: изготовление кап",
  S_PRODUCTION_QUALITY_CONTROL: "Контроль качества",
  S_FINAL_STAGE_READY: "Капы финального этапа готовы",
  S_TREATMENT_FINISHED: "Лечение завершено",
  S_CANCEL_TREATMENT: "Отказался от лечения",
  S_RETAINERS_ORDERED: "Заявка обрабатывается (ретенционные капы)",
  S_RETAINERS_RETAKE_IMPRESSIONS: "Ретенционные капы - ожидание информации",
  S_RETAINERS_WAITING_FOR_A_PAYMENT: "Ретенционные капы - ожидание оплаты",
  S_RETAINERS_3D_SCANNING: "Ретенционные капы - сканирование",
  S_RETAINERS_PRINTING: "Ретенционные капы - печать",
  S_RETAINERS_FABRICATING: "Ретенционные капы - изготовление",
  S_RETAINERS_READY: "Ретенционные капы готовы",
  S_POWER_CAP_ORDERED: "Заявка обрабатывается (силовая капа)",
  S_POWER_CAP_RETAKE_IMPRESSIONS: "Силовая капа — ожидание информации",
  S_POWER_CAP_WAITING_FOR_A_PAYMENT: "Силовая капа — ожидание оплаты",
  S_POWER_CAP_3D_SCANNING: "Силовая капа — сканирование",
  S_POWER_CAP_3D_PLAN_MODELING: "Силовая капа — моделирование",
  S_POWER_CAP_3D_PLAN_APPROVAL: "Утвердите план силовой капы",
  S_POWER_CAP_3D_PLAN_MODELS_BUILDING: "Силовая капа — подготовка моделей",
  S_POWER_CAP_PRODUCTION_PRINTING: "Силовая капа — печать",
  S_POWER_CAP_PRODUCTION_MOLDING: "Силовая капа — формовка",
  S_POWER_CAP_PRODUCTION_MARKING: "Силовая капа — маркировка",
  S_POWER_CAP_PRODUCTION_ALLOCATING: "Силовая капа — комплектация",
  S_POWER_CAP_PRODUCTION_FABRICATING: "Силовая капа — изготовление",
  S_POWER_CAP_PRODUCTION_QUALITY_CONTROL: "Силовая капа — контроль качества",
  S_POWER_CAP_READY: "Силовая капа готова",
  // Raw backend status sent without the `S_` prefix (not in the `Status` enum) — the status badge renders
  // it verbatim via `<FormattedMessage id={status} />`, so the message id is the bare string.
  // Value shared with the additional-service tag of the same name, below.

  // Create patient page
  BLOCKHEAD_DOCTOR: "Информация о враче",
  HEADER_DOCTOR: "Врач",
  HEADER_CLINIC: "Клиника",
  CLINIC_SHIP_COMMENTS: "Комментарии по логистике ",
  CLINIC_SHIP_COMMENTS_PLACEHOLDER: "Комментарии",
  BLOCKHEAD_PAYMENT: "Оплата",
  HEADER_PAYMENT_METHOD: "Способ оплаты",
  HEADER_PAYER: "Плательщик",
  HEADER_PROMO_CODE: "Акция",
  HEADER_PROMO_CODE_PLACEHOLDER: "Введите название акции (при наличии)",
  PAYER_CLINIC: "Клиника",
  PAYER_DOCTOR: "Врач",
  PAYER_PATIENT: "Пациент",
  PM_CASH: "Наличный расчет",
  PM_BANK: "Безналичный расчет",
  PM_INVOICE: "Безналичный расчет",
  PM_CARD: "Оплата картой в Личном Кабинете",
  PM_CARD_ONLINE: "Оплата банковской картой",
  HEADER_PAYMENT_OPTION: "Варианты оплаты",
  PO_ADVANCE: "100% предоплата",
  PO_SPLIT_2: "Рассрочка в два этапа",
  PO_SPLIT_2_2: "Рассрочка в два этапа",
  PO_SPLIT_3: "Рассрочка в три этапа (+10 000 руб.)",
  PO_SPLIT_3_2: "Рассрочка в три этапа (+10 000 руб.)",
  "exclusive.payment_option": "Рассрочка в два этапа: 20 000 руб. + оплата за капы",
  "payment.caps_label": "Оплата за капы",
  PO_SPLIT_3_NO_OVERPAY: "Рассрочка в три этапа",
  PO_CREDIT_SB: "Покупай со Сбером в кредит",
  PO_CREDIT_SB_COND: "(условия кредитования)",
  PS_3D_PLAN: "Оплачен только 3D план",
  PS_HALF_PRICE: "Оплачена половина этапов",
  PS_FULL_PRICE: "Оплачены все этапы",
  BLOCKHEAD_PAT_INFO: "Информация о пациенте",
  PAT_INFO_LAST_NAME: "Фамилия",
  PAT_INFO_LAST_NAME_PLACEHOLDER: "Фамилия пациента",
  PAT_INFO_NAME_TOOLTIP: "ФИО пациента не подлежит изменению после отправки заявки в работу",
  PAT_INFO_FIRST_NAME: "Имя",
  PAT_INFO_FIRST_NAME_PLACEHOLDER: "Имя пациента",
  PAT_INFO_MIDDLE_NAME: "Отчество",
  PAT_INFO_MIDDLE_NAME_PLACEHOLDER: "Отчество пациента",
  PAT_EMAIL: "Email плательщика",
  PAT_INFO_EMAIL_PLACEHOLDER: "Email (на указанный Email будет выслана ссылка для оплаты)",
  HEADER_SEX: "Пол",
  SEX_F: "Женский",
  SEX_M: "Мужской",
  HEADER_BDATE: "Дата рождения",
  HEADER_CONDITION: "Диагноз / Клиническое состояние",
  CONDITION_PLACEHOLDER: "Основная жалоба / Диагноз",
  BLOCKHEAD_INSTRUCTIONS: "Рецепт",
  HEADER_INSTRUCTIONS: "Курс лечения",
  "patient.form.course.title": "Выберите услугу",
  "patient.form.payment.title": "Способ оплаты",
  ATTACHMENT_INSTRUCTIONS: "Выберите одну из опций",
  ADDITIONAL_INSTRUCTIONS: "Дополнительные услуги",
  C_MATCHING: "Совмещение КТ и скана зубных рядов",

  // Courses
  C_LIMITLESS: "Безлимитный",
  C_LIMITLESS_COMMENT: " (курс включает: глубокий анализ КТ, виртуальный 3D план, неограниченное количество этапов и коррекций, 1 пара ретейнеров)",
  C_TRANSPARENT: "Прозрачный",
  C_TRANSPARENT_COMMENT: " (КТ включён, рассрочка в два этапа: 20 000 руб. + оплата за капы)",
  C_EXPERT: "Экспертный",
  C_EXPERT_COMMENT: " (курс включает: глубокий анализ КТ, виртуальный 3D план, неограниченное количество этапов в основном плане, 3 коррекции)",

  C_POWER_CAP: "Силовая капа",
  C_POWER_CAP_V2: "Силовая капа",
  C_POWER_CAP_COMMENT: " ",
  C_POWER_CAP_COMMENT_V2: " ",
  C_LIMITLESS_V2: "Безлимитный",
  C_LIMITLESS_COMMENT_V2: " (курс включает: глубокий анализ КТ, виртуальный 3D план, неограниченное количество этапов и коррекций, 1 пара ретейнеров)",
  // Course names are shared across price versions; no version-specific marketing copy is available.
  C_LIMITLESS_V3: "Безлимитный",
  C_LIMITLESS_COMMENT_V3: " ",
  C_LIMITLESS_V4: "Безлимитный",
  C_LIMITLESS_COMMENT_V4: " ",

  C_FULL: "Полный",
  C_FULL_V2: "Полный",
  C_FULL_V3: "Полный",
  C_FULL_V4: "Полный",
  C_FULL_3_STEPS_CBCT_V2: "Полный (рассрочка в 3 этапа, Глубокий анализ КТ)",
  C_FULL_COMMENT: " (3D план движения коронок, 3 коррекции, неограниченное количество этапов)",
  C_FULL_COMMENT_V2: " (курс включает: виртуальный 3D план, до 30 этапов в основном плане, 2 коррекции)",
  C_FULL_COMMENT_V3: " (курс включает: глубокий анализ КТ, виртуальный 3D план, до 30 этапов в основном плане, 3 коррекции)",
  C_FULL_COMMENT_V4: " (курс включает: глубокий анализ КТ, виртуальный 3D план, до 30 этапов в основном плане, 3 коррекции)",

  C_TEEN: "Подростки",
  C_TEEN_V2: "Подростки",
  C_TEEN_V3: "Подростки",
  C_TEEN_COMMENT: " (курс включает: виртуальный 3D план, неограниченное количество этапов, 3 коррекции)",
  C_TEEN_COMMENT_V2: " (курс включает: виртуальный 3D план, неограниченное количество этапов, 3 коррекции)",
  C_TEEN_COMMENT_V3: " (курс включает: глубокий анализ КТ, виртуальный 3D план, неограниченное количество этапов, 3 коррекции)",

  C_SHORT: "Короткий",
  C_SHORT_V2: "Короткий",
  C_SHORT_V3: "Короткий",
  C_SHORT_COMMENT: " (3D план движения коронок, до 14 этапов на 2 челюсти)",
  C_SHORT_COMMENT_V2: " (курс включает: виртуальный 3D план, не более 14 этапов)",
  C_SHORT_COMMENT_V3: " (курс включает: глубокий анализ КТ, виртуальный 3D план, не более 14 этапов, 1 коррекция)",

  C_ONE_JAW: "Лечение одной челюсти",
  C_ONE_JAW_V2: "Курс на одну челюсть",
  C_ONE_JAW_V3: "Курс на одну челюсть",
  C_ONE_JAW_COMMENT: " (3D план движения коронок, 2 коррекции, неограниченное количество этапов на 1 челюсть)",
  C_ONE_JAW_COMMENT_V2: " (курс включает: виртуальный 3D план, неограниченное количество этапов, 2 коррекции)",
  C_ONE_JAW_COMMENT_V3: " (курс включает: глубокий анализ КТ, виртуальный 3D план, неограниченное количество этапов, 2 коррекции)",

  C_SUPER_SHORT: "Супер-короткий",
  C_SUPER_SHORT_V2: "Супер-короткий курс до 8 этапов",
  C_SUPER_SHORT_COMMENT: " (3D план движения коронок, до 8 кап на 1 челюсть)",
  C_SUPER_SHORT_COMMENT_V2: " (курс включает: виртуальный 3D план, не более 8 кап на одну челюсть)",

  C_UNLIMITED: "Курс с моделированием движения корней",
  C_UNLIMITED_V2: "Курс с моделированием движения корней",

  C_UNLIMITED_COMMENT: " (глубокий анализ КТ, 3D план движения корней и коронок, 3 коррекции, неограниченное количество этапов)",
  C_UNLIMITED_COMMENT_V2: " (курс включает: глубокий анализ КТ, виртуальный 3D план движения корней и коронок, неограниченное количество этапов, 3 коррекции)",

  C_3DSMILE_PRO: "3D Smile Pro",
  C_3DSMILE_PRO_COMMENT:
    "Данный курс действует для врачей любой специальности, студентов медицинских ВУЗов, сотрудников стоматологических клиник (курс включает: глубокий анализ КТ, виртуальный 3D план движения корней и коронок, 3 коррекции, неограниченное количество этапов)",

  C_3D_PLAN: "Только 3D план",

  C_3D_PLAN_V2: "Только 3D план",
  C_3D_PLAN_COMMENT_V2: " ",

  C_CHILDREN: "Дети",
  C_CHILDREN_V2: "Курс ДЕТИ",
  C_CHILDREN_V3: "Дети Безлимитный",
  C_CHILDREN_V4: "Дети Безлимитный",
  C_CHILDREN_COMMENT: " ",
  C_CHILDREN_COMMENT_V2: " (курс включает капы на 2 челюсти, 1 коррекция)",
  C_CHILDREN_COMMENT_V3: " (курс включает: виртуальный 3D план, неограниченное количество этапов в течение 18 месяцев)",
  C_CHILDREN_COMMENT_V4: " (курс включает: виртуальный 3D план, неограниченное количество этапов в течение 18 месяцев)",

  C_CHILDREN_SHORT: "Дети Экспресс",
  C_CHILDREN_SHORT_V1: "Дети Экспресс",
  C_CHILDREN_SHORT_COMMENT: " ",
  C_CHILDREN_SHORT_COMMENT_V1: " (курс включает: виртуальный 3D план, не более 24 кап - одна или две челюсти)",

  C_RETAINERS: "Ретенционные капы",
  C_RETAINERS_V2: "Ретенционные капы",
  C_RETAINERS_V3: "Ретенционные капы",
  C_RETAINERS_COMMENT: " ",
  C_RETAINERS_COMMENT_V2: " ",
  C_RETAINERS_COMMENT_V3: " ",

  C_ADDITIONAL_ALIGNERS: "Дубликаты кап",
  C_ADDITIONAL_ALIGNERS_V2: "Дубликаты кап",
  C_ADDITIONAL_ALIGNERS_COMMENT_V2: " ",

  RETAINERS: "Ретенционные капы (2 пары)",
  RETAINERS_ONE: "Ретенционные капы (1 пара)",
  RETAINERS_ONE_ARCH: "Ретенционные капы",
  RETAINERS_LOWER_ARCH: "Ретенционные капы для нижней челюсти (2)",
  RETAINERS_LOWER_ARCH_ONE: "Ретенционные капы для нижней челюсти (1)",
  RETAINERS_QUANTITY: "Количество комплектов ретейнеров",
  RETAINERS_UPPER_ARCH: "Ретенционные капы для верхней челюсти (2)",
  RETAINERS_UPPER_ARCH_ONE: "Ретенционные капы для верхней челюсти (1)",
  POWER_CAP: "Силовая капа (обе челюсти)",
  POWER_CAP_UPPER: "Силовая капа для верхней челюсти",
  POWER_CAP_LOWER: "Силовая капа для нижней челюсти",
  POWER_CAP_ONE_ARCH: "Силовая капа (одна челюсть)",
  CBCT_ANALYSIS: "Глубокий анализ КТ",
  CBCT_ANALYSIS_3D_PLAN: "Глубокий анализ КТ",
  DELIVERY: "Доставка",
  PRESCRIPTION_TRANSCRIBING: "Экспертное сопровождение",
  PRESCRIPTION_WITH_EXPERT: "Экспертное сопровождение",
  FAST_3D_PLAN: "Ускоренное изготовление 3D-Плана",
  FAST_CAPS_PRINTING: "Ускоренное производство кап (печать)",
  LEAD_TECHNICIAN_3D_PLAN: "3D-моделирование от ведущего техника",
  "additional.services.add_to_course": "К курсу вы можете добавить:",
  "additional.services.list.title": "Дополнительные услуги",
  "recipe.mode.question": "Как вы хотите подготовить рецепт?",
  "recipe.mode.self.title": "Самостоятельно",
  "recipe.mode.self.description": "Заполните рецепт в\u00a0привычном формате. Самостоятельно задайте параметры лечения, " + "необходимые перемещения и\u00a0пожелания к\u00a0будущему 3D плану",
  "recipe.mode.expert.title": "Экспертное сопровождение",
  "recipe.mode.expert.badge": "Новая услуга",
  "recipe.mode.expert.price": "{price}",
  "recipe.mode.expert.blocked.no_course": "Сначала выберите услугу — от неё зависит доступность этого варианта",
  "recipe.mode.expert.blocked.unavailable": "Для выбранного курса эта услуга недоступна",
  "recipe.mode.expert.description":
    "Расскажите о\u00a0клинической задаче и\u00a0желаемом результате. Клинический эксперт и\u00a0ведущий " +
    "техник возьмут на\u00a0себя детализацию ваших клинических целей и\u00a0их реализацию в\u00a03D-плане.",
  "recipe.mode.expert.benefit.time.title": "Экономия времени",
  "recipe.mode.expert.benefit.time.text": "Делегируйте рутину по\u00a0заполнению рецепта лаборатории — просто надиктуйте клиническую задачу и\u00a0важные детали голосом.",
  "recipe.mode.expert.benefit.voice.title": "Клиническая экспертиза",
  "recipe.mode.expert.benefit.voice.text": "Перед моделированием рецепт проверит клинический эксперт: при необходимости задаст уточняющие вопросы и\u00a0дополнит рецепт важными деталями.",
  "recipe.mode.expert.benefit.support.title": "Ведущий техник-моделировщик",
  "recipe.mode.expert.benefit.support.text": "Ваш кейс моделирует ведущий техник-моделировщик с\u00a0глубокой экспертизой в\u00a0планировании лечения на\u00a0элайнерах.",
  "additional.services.smart.recipe.accordion_title": "Рецепт",
  "additional.services.smart.recipe.accordion_subtitle": "Сформирован на основе вашей записи",
  "additional.services.smart.tooltip.title": "Экспертное сопровождение",
  "additional.services.smart.tooltip.subtitle": "Делегируйте рутинное оформление рецепта специалистам лаборатории.",
  "additional.services.smart.tooltip.how_it_works": "Как это работает:",
  "additional.services.smart.tooltip.description":
    "Вам больше не нужно тратить время на внесение данных и сортировку вложений. " +
    "Просто надиктуйте рецепт голосом и загрузите все необходимые файлы в единое окно. " +
    "Все остальное мы сделаем за вас: корректно заполним форму рецепта, прикрепим материалы " +
    "и подготовим рецепт к финальному согласованию.",
  "additional.services.smart.audio.title": "Голосовой ввод рецепта",
  "additional.services.smart.audio.recipe_title": "Расскажите о клинической задаче",
  "additional.services.smart.processing.title": "Идет обработка записи",
  "additional.services.smart.processing.update_title": "Обновляем рецепт",
  "additional.services.smart.processing.step": "Шаг {number}:",
  "additional.services.smart.processing.audio.upload": "Загружаем голосовой рецепт",
  "additional.services.smart.processing.audio.process": "Обрабатываем запись",
  "additional.services.smart.processing.audio.analyze": "Анализируем содержание",
  "additional.services.smart.processing.update.remove": "Удаляем запись",
  "additional.services.smart.processing.update.recipe": "Обновляем рецепт",
  "additional.services.smart.processing.update.check": "Проверяем изменения",
  "additional.services.smart.audio.recording_now": "Запись аудио",
  "additional.services.smart.audio.recording_hint":
    "Какой результат хотите получить, какие перемещения планируете, нужно ли менять положение " + "нижней челюсти, что еще важно учесть: удаления, тремы, аттачменты или другие особенности",
  "additional.services.smart.audio.recording_active_hint": "Максимально 15 мин — Повторно нажмите для завершения записи",
  "additional.services.smart.audio.recording_ending_hint": "Осталось {seconds} сек — запись завершится автоматически",
  "additional.services.smart.audio.records_title": "Все записи",
  "additional.services.smart.audio.record_name": "Голосовое сообщение {number}",
  "additional.services.smart.audio.speed_toggle": "Скорость воспроизведения",
  "additional.services.smart.audio.status.empty": "Транскрипт пока отсутствует.",
  "additional.services.smart.audio.status.processing": "Транскрибируется...",
  "additional.services.smart.audio.status.ready": "Транскрипт готов.",
  "additional.services.smart.audio.upload": "Загрузить аудио",
  "additional.services.smart.audio.start_recording": "Нажмите для записи",
  "additional.services.smart.audio.stop_recording": "Остановить запись",
  "additional.services.smart.audio.uploading": "Загрузка аудио...",
  "additional.services.smart.audio.file_uploaded": "Загружен файл: {fileName}",
  "additional.services.smart.audio.total_duration": "Общая длительность аудио: {minutes} мин {seconds} сек",
  "additional.services.smart.audio.duration_limit": "Суммарная длительность аудио не должна превышать 30 минут.",
  "additional.services.smart.audio.transcript": "Текст рецепта",
  "additional.services.smart.audio.upload_error": "Не удалось загрузить аудио. Попробуйте еще раз.",
  "additional.services.smart.audio.processing_error": "Не удалось обработать аудио. Удалите запись и попробуйте еще раз.",
  "additional.services.smart.audio.unsupported_format": "Неподдерживаемый формат аудио. Используйте OGG, MP3 или WAV.",
  "additional.services.smart.audio.recording_not_supported": "Браузер не поддерживает запись аудио с микрофона.",
  "additional.services.smart.audio.recording_error": "Не удалось начать запись. Проверьте доступ к микрофону.",
  "additional.services.smart.audio.mic_blocked": "Браузер заблокировал доступ к микрофону. Разрешите его в настройках сайта — значок слева от адреса страницы — и начните запись заново.",
  "additional.services.smart.audio.mic_not_found": "Микрофон не найден. Подключите микрофон и начните запись заново.",
  "additional.services.smart.audio.mic_busy": "Микрофон занят другой программой (например, Zoom или Teams). Закройте её и начните запись заново.",
  "additional.services.smart.audio.mic_unavailable": "Не удалось включить микрофон. Проверьте, что он подключён и доступ к нему разрешён, затем начните запись заново.",
  "additional.services.smart.generate_slow": "Модель отвечает дольше обычного. Она продолжает обрабатывать запись — нажмите «Проверить результат», чтобы проверить результат ещё раз.",
  "additional.services.smart.audio.remove_disabled_tooltip": "Удаление доступно только при создании пациента",
  C_ANTHROPOMETRIC_DIAGNOSTIC: "Антропометрический анализ 3D-моделей  (протокол антропометрической диагностики МГМСУ) - 5000 руб",
  C_ANTHROPOMETRIC_DIAGNOSTIC_ITEM: "Антропометрический анализ 3D-моделей  (протокол антропометрической диагностики МГМСУ)",
  C_IMPRESSIONS: "Я буду использовать слепки",
  C_SCAN: "Я буду использовать скан",
  C_TEST_PLASTIC_YES: "Я буду использовать новый пластик",
  C_TEST_PLASTIC_NO: "Я буду использовать регулярный пластик",
  C_YES_CT_CORRECTION: "Коррекция будет с КТ",
  C_NO_CT_CORRECTION: "Коррекция будет без КТ",
  C_DEEP_CBCT_ANALYSIS: "Глубокий анализ КТ — 20 000 ₽",
  C_DEEP_CBCT_ANALYSIS_ITEM: "Глубокий анализ КТ",
  HEADER_ARCHES: "Зубные дуги",
  ARCHES_SELECT: "Необходимо лечить зубные дуги",
  TA_BOTH: "Обе",
  TA_UPPER: "Верхняя",
  TA_LOWER: "Нижняя",

  TA_OCCLUSAL: "Окклюзионная плоскость | Линия-горизонт",
  TA_P_OCCLUSAL: "Нет наклона",
  TA_R_OCCLUSAL: "Наклон вправо",
  TA_L_OCCLUSAL: "Наклон влево",
  TA_OCCLUSAL_SAVE: "Сохранить",
  TA_OCCLUSAL_MODIFY: "Модифицировать:",
  TA_OCCLUSAL_TEETH_EXTRUDE: "Экструзировать зубы:",
  TA_OCCLUSAL_TEETH_INTRUDE: "Интрузировать зубы:",
  ARCHES_U_SELECT: "Форма дуги верхнего зубного ряда",
  STAGE: "Этап",
  AMOUNT: "Количество",
  UPPER_ARCH: "для верхней дуги",
  LOWER_ARCH: "для нижней дуги",
  SELECT_TREAT_ARCHES: "Выберите зубные дуги",
  TA_U_MAINTAIN: "Не менять",
  TA_U_EXPAND: "Расширить",
  TA_U_NARROW: "Сузить",
  TA_U_EXPAND_TYPE_TORQUE: "Торковое",
  TA_U_EXPAND_TYPE_BODILY: "Корпусное",
  TA_U_EXPAND_TYPE_HOWTO: "Засчет чего",
  TA_U_CORRECTION_BOTH: "расширение торковое и корпусное",
  TA_U_CORRECTION_TORQUE: "расширение торковое",
  TA_U_CORRECTION_BODILY: "расширение корпусное",
  ARCHES_L_SELECT: "Форма дуги нижнего зубного ряда",
  TA_L_MAINTAIN: "Не менять",
  TA_L_EXPAND: "Расширить",
  TA_L_NARROW: "Сузить",
  ARCHES_TLA_UPPER: "Выравнивание зубов на в/ч",
  ARCHES_TLA_LOWER: "Выравнивание зубов на н/ч",
  TLA_G_MARGIN: "По десневому краю",
  TLA_C_EDGE: "По режущему краю",
  HEADER_INCISORS: "Соотношение резцов",
  INCISORS_VO: "Соотношение резцов по вертикали",
  VO_MAINTAIN: "Не менять",
  VO_DECREASE: "Уменьшить резцовое перекрытиe",
  VO_INCREASE: "Увеличить резцовоe перекрытиe",
  VO_COMMENT: "За счет чего изменить глубину",
  VO_COMMENT_PLACEHOLDER: " ",
  INCISORS_HO: "Соотношение резцов по сагиттали",
  INCISORS_HO_U: "Верхние резцы",
  HO_U_MAINTAIN: "Не менять",
  HO_U_RETROCLINATE: "Устранить протрузию",
  HO_U_PROCLINATE: "Устранить ретрузию",
  INCISORS_HO_L: "Нижние резцы",
  HO_L_MAINTAIN: "Не менять",
  HO_L_RETROCLINATE: "Устранить протрузию",
  HO_L_PROCLINATE: "Устранить ретрузию",
  OVERJET: "Сагиттальная щель",
  OJ_MAINTAIN: "Не менять",
  OJ_CONTACT: "Установить резцы в контакт",
  OJ_MAINTAIN_LARGE: "Оставить сагиттальную щель",
  OJ_MAINTAIN_CORRECT: " ",
  OJ_MAINTAIN_CORRECT_SPECIFY: " ",
  DISPLACEMENT_LOWER: "Планируется ли смещение нижней челюсти",
  CORRECT_RETROCLINATION_UPPER: " ",
  CORRECT_PROCLINATION_LOWER: " ",
  CORRECT_PROCLINATION_UPPER: " ",
  CORRECT_RETROCLINATION_LOWER: " ",
  MIDLINE: "Соотношение резцов по трансверзали (средняя линия)",
  ML_MAINTAIN: "Не менять",
  ML_ADJUST_LOWER_TO_UPPER: " ",
  ML_ADJUST_UPPER_TO_LOWER: " ",
  ML_IMPROVE: "Улучшить (за счет каких движений):",
  HEADER_CANINE: "Соотношение клыков",
  HEADER_CANINE_DESCRIPTION: "(которое желаете получить на финальном этапе)",
  CANINE_RIGHT: "Справа",
  CR_R_I_CLASS: "I класс",
  CR_R_II_CLASS: "II класс",
  CR_R_III_CLASS: "III класс",
  CANINE_LEFT: "Слева",
  CR_L_I_CLASS: "I класс",
  CR_L_II_CLASS: "II класс",
  CR_L_III_CLASS: "III класс",
  CANINE_HOWTO: "За счет чего",
  CRH_DISTALIZE: "Дистализация",
  CRH_MESIALIZE: "Мезиализация",
  CRH_IPR: "Сепарация (IPR)",
  CRH_AI: " ",
  CRH_SPECIFY: " ",
  HEADER_MOLAR: "Соотношение первых моляров",
  HEADER_MOLAR_DESCRIPTION: "(которое желаете получить на финальном этапе)",
  MOLAR_RIGHT: "Справа",
  MR_R_MAINTAIN: "Не менять",
  MR_R_I_CLASS: "I класс",
  MR_R_II_CLASS: "II класс",
  MR_R_III_CLASS: "III класс",
  MOLAR_LEFT: "Слева",
  MR_L_I_CLASS: "I класс",
  MR_L_II_CLASS: "II класс",
  MR_L_III_CLASS: "III класс",
  MOLAR_HOWTO: "За счет чего",
  MRH_DISTALIZE: "Дистализация",
  MRH_MESIALIZE: "Мезиализация",
  MRH_IPR: "Сепарация (IPR)",
  MRH_AI: " ",
  IPR_TRUE: "Использовать IPR",
  HEADER_ELASTICS: "Использование эластичной тяги",
  ELASTICS_RIGHT: "Справа",
  ER_R_I_CLASS: "I класс",
  ER_R_II_CLASS: "II класс",
  ER_R_III_CLASS: "III класс",
  ER_NONE: "Не использовать",
  ELASTICS_LEFT: "Слева",
  ER_L_I_CLASS: "I класс",
  ER_L_II_CLASS: "II класс",
  ER_L_III_CLASS: "III класс",
  BUTTONS_AND_HOOKS: "Использовать крючки или кнопки",
  HOOK: "Крючок",
  BUTTON: "Кнопка",
  CANCEL: "нажмите для отмены",
  HEADER_CLOSE_ALL: "Закрыть все промежутки",
  CAG_YES: "Да",
  CAG_MAINTAIN: "Сохранить диастему / тремы",
  CAG_LEAVE_SPACE: "Сохранить класс соотношения зубов, при этом оставить промежуток/промежутки:",
  CAG_LEAVE_SPACE_FOR: "За счет чего изменить глубину",
  CAG_LEAVE_SPACE_ADD_COMMENT: "Введите комментарий",
  CAG_LEAVE_SPACE_COMMENT: "(укажите номер зуба и расстояние в миллиметрах)",
  TOOTH_NUMBER: "зуб",
  TOOTH_NUMBER_PLACEHOLDER: "Укажите номер зуба",
  DISTANCE_IN_MILLIMETRES: "расстояние в миллиметрах",
  DISTANCE_IN_MILLIMETRES_PLACEHOLDER: "Укажите расстояние в миллиметрах *",
  MILLIMETRES: "мм",
  ADD_FIELD: "Добавить поле",
  EXTRA_NOMOVE: "Не перемещать следующие зубы (мосты, имплантаты, анкилозированные зубы, другое)",
  EXTRA_NOLOCK: "Избегать установку замков на следующих зубах (коронки, другое)",
  EXTRA_EXTRACT: "Удалить следующие зубы",
  EXTRA_HOOK: "Отметьте зуб галочкой, где будет установлен крючок",
  EXTRA_BUTTON: "Отметьте зуб галочкой, где будет установлена кнопка",
  EXTRA_TEETHING: "Оставить место для прорезывания зубов",
  EXTRA_COMMENTS: "Комментарии (какой результат Вы хотите получить), прочие инструкции ",
  EXTRA_COMMENTS_PLACEHOLDER: "Комментарии",
  treatment_goals_ex: "примеры",
  treatment_goals_ex_1: " ",
  treatment_goals_ex_2: " ",
  treatment_goals_ex_3: " ",
  UPLOADED_FILES: "Загруженные STL, фото, ОПТГ и другие файлы",
  UPLOAD_FHOTOS: "Фотографии до лечения",
  UPLOADED_CBCT: "Загруженные файлы КТ",
  CBCT_LINKS: "Ссылки на КТ",
  LINK: "Ссылка",
  CREATED_AT: "Добавлена",
  OPEN: "Копировать",

  COMING_SOON: " ",

  LINK_TO_MANUAL: "Инструкция",
  UPLOAD_FILES: "Загрузите STL, фото, ОПТГ и другие файлы",
  "patient.files.other_materials": "Другие материалы пациента",
  "patient.files.other_materials_hint": "Загрузите STL, фото, ОПТГ, КТ (в ZIP-архиве или ссылкой) и другие файлы",
  "patient.files.dropzone.hint": "Перетащите выбранные файлы в это окно или выберите на устройстве. " + "Можно загрузить несколько файлов одновременно",
  "patient.files.dropzone.hint_mobile": "Выберите несколько файлов на устройстве либо загрузите их " + "по одному ниже в соответствующее окно",
  "patient.files.dropzone.choose": "Выбрать файлы",
  "patient.files.clear_all": "Очистить все",
  "patient.files.ct_link_label": "Ссылка на КТ (DICOM)",
  "patient.files.uploaded_title": "Загруженные файлы",
  "patient.files.size.mb": "МБ",
  "patient.files.size.kb": "КБ",
  "patient.files.size.bytes": "Б",
  UPLOAD_FILES_SMART: "Загрузите все необходимые файлы (STL, фото, ОПТГ и другие файлы)",
  ADD_LINK_TO_CT: "Ссылка на КТ",
  UPLOAD_BTN: "Загрузите фото",
  UPLOAD_FILE_BTN: "Загрузить файлы",
  FILE_UPLOAD_REMOVE: "Удалить файл",
  FILE_UPLOAD_UPLOADING: "Загрузка…",
  DISK_CBCT: "КТ на диске",
  PHOTO_PROFILE: "Фото в профиль",
  PHOTO_SMILE: "Фото анфас с улыбкой",
  PHOTO_PORTRATE: "Фото анфас",
  PHOTO_UPPER_OCCLUSAL: "Окклюзионный вид верхнего зубного ряда",
  PHOTO_LOWER_OCCLUSAL: "Окклюзионный вид нижнего зубного ряда",
  PHOTO_RIGHT: "Латеральный вид зубного ряда справа",
  PHOTO_FRONT: "Фронтальный вид зубного ряда",
  PHOTO_LEFT: "Латеральный вид зубного ряда слева",
  // In-browser photo classifier (docs/features/photo-classifier.md)
  "photo_classifier.loading": "Подготавливаем фотографии…",
  "photo_classifier.preparing": "Подготавливаем фотографии…",
  "photo_classifier.classifying": "Распознаём и распределяем фотографии…",
  "photo_classifier.rotate_left": "Влево",
  "photo_classifier.rotate_right": "Вправо",
  "photo_classifier.flip_horizontal": "Отразить по горизонтали",
  "photo_classifier.flip_vertical": "Отразить по вертикали",
  "photo_classifier.expand_photo": "Увеличить фото",
  "photo_classifier.remove_photo": "Удалить фото",
  "photo_classifier.limit_hint": "Можно добавить не\u00a0более {max} фотографий.",
  "photo_classifier.limit_reached": "Достигнут лимит: {max} фотографий. Чтобы загрузить другую, сначала удалите одну.",
  "photo_classifier.protocol_hint": "Загрузите фотографии пациента во всех необходимых ракурсах",
  "photo_classifier.auto_detect_badge": "Система автоматически определит тип фото и распределит в нужное поле",
  "photo_classifier.upload_into_slot": "Загрузить фото: {view}",
  "photo_classifier.photo_index": "{index} из {total}",
  "photo_classifier.prev_photo": "Предыдущее фото",
  "photo_classifier.next_photo": "Следующее фото",
  "photo_classifier.unavailable_browser":
    "Автоматическое распознавание фотографий недоступно: ваш браузер не поддерживает нужные технологии. Обновите браузер до последней версии. Фотографии можно загрузить вручную — по одной на каждый вид.",
  "photo_classifier.unavailable_config":
    "Автоматическое распознавание фотографий недоступно из-за настроек безопасности. Обратитесь в службу технической поддержки. Фотографии можно загрузить вручную — по одной на каждый вид.",
  "photo_classifier.unavailable_slow":
    "Автоматическое распознавание фотографий недоступно: на этом устройстве оно работает слишком медленно. Фотографии можно загрузить вручную — по одной на каждый вид.",
  "photo_classifier.unavailable_error":
    "Не удалось распознать фотографии из-за внутренней ошибки. Обратитесь в службу технической поддержки. Фотографии можно загрузить вручную — по одной на каждый вид.",
  PHOTO_BEFORE: "До лечения",
  PHOTO_CORRECTION: "Коррекция",
  BTN_ADD_FILES: "Добавить файлы",
  BTN_CHOOSE_FILES: "Выбрать файлы",
  BTN_CHOOSE_PHOTO: "Выбрать фото",
  BTN_SUBMIT: "Отправить",
  BTN_SUBMIT_NEW: "Отправить в работу",
  BTN_EDIT: "Редактировать",
  BTN_CHANGE_PASSWORD: "Изменить пароль",
  BTN_SAVE: "Сохранить",
  BTN_SAVE_DRAFT: "Сохранить черновик",
  BTN_SAVE_DRAFT_CONTINUE_LATER: "Хотите сохранить данные пациента в черновиках и продолжить заполнение позже?",
  BTN_SAVE_CONTINUE_LATER: "Хотите сохранить данные пациента и продолжить заполнение позже?",
  REQUIRED_FIELDS_FOR_A_DRAFT: "Пожалуйста, заполните обязательные поля",
  EXIT_WITHOUT_SAVING: "Выйти без сохранения?",
  STAY_HERE: "Остаться здесь",
  CBCT_UPLOAD_HEADER: "Загрузите файлы КТ",
  CBCT_UPLOADED_HEADER: "Загруженные файлы",
  HOW_UPLOAD_CBCT: " ",
  CBCT_DETAILS: "инструкция по загрузке файлов",
  CBCT_UPLOAD_PROGRESS_TITLE: "Загружается {filesCount} файл(-ов)",
  CBCT_UPLOAD_COMPLETE: "Загрузка завершена",
  CBCT_UPLOAD_ERROR: "Ошибка загрузки",
  SCAN_UPLOAD_SCAN_WARNING: "Не забудьте загрузить скан",
  SCAN_UPLOAD_CT_WARNING: "Не забудьте загрузить КТ (в архиве .zip)",
  "3D_SMILE_PRO_WARNING": "Необходимо загрузить справку пациента с места работы/учебы, подтверждающую его должность врача/сотрудника стоматологической клиники или статус студента медицинского ВУЗа.",
  ADDITIONAL_ALIGNERS: "Дубликаты кап",
  ADDITIONAL_ALIGNERS_TRANSPARENT: "Дубликаты кап",
  SAA_PROCESSING: "Заявка обрабатывается",
  SAA_READY: "Дубликаты кап готовы",
  "all.additional.aligners": "смотреть все дубликаты",
  "additional.aligners.patients": "Отдельные заявки",

  // Footer
  "page.footer.header": "© ООО «3Д Смайл»",
  "page.footer.content": "3D Smile. Высокие технологии движения зубов!",

  "page.footer.contacts": "Контакты",
  "page.footer.payment": "Оплата",
  "page.footer.version": "Версия",
  "plan.approve.header": "Утверждение 3D-плана",
  "plan.approve.body": "Утвердить план:",
  "plan.approve.btn": "Утвердить",
  "plan.confirm_plan.btn": "Утвердить",
  "plan.approve.no_clinic": "В профиле пациента не указана клиника.",
  "plan.approve.redirect": "Перейти в профиль",
  "plan.approve.accept": "Я прочитал и согласен с условиями",
  "plan.approve.postpone": "Отложить утверждение",
  "plan.rework.header": "Доработка 3D-плана",
  "plan.rework.body": "Номер плана:",
  "plan.rework.btn": "Отправить на доработку",
  "plan.cancel.header": "Скорректировать 3D-план",
  "plan.cancel.body": "План:",
  "plan.cancel.stage": "Номер этапа",
  "plan.cancel.scroll.to.field": "Нажмите, чтобы перейти к полю",
  "plan.cancel.btn": "Скорректировать план",
  "plan.cancel.opt_out_test_plastic.description": "Вы уверены, что <bold>не хотите</bold> использовать новый пластик для продолжения лечения?",
  "plan.order.btn": "Заказать",
  "change.password": "Изменить пароль",
  "change.password.match": "Пароли не совпадают",
  "enter.password": "Введите новый пароль",
  "re-enter.password": "Повторите новый пароль",
  "treatment.correct.header": "Скорректировать лечение",
  "treatment.additional_course.header": "Дополнительный комплект",
  "correction.ct.notifcation": "Загружен КТ файл",
  "recipe.check.title": "Обязательные поля",
  "recipe.check.reference.steps": "Номер этапа",
  "recipe.check.reference.photos": "Фотографии пациента",
  "recipe.check.reference.material": "Использовать скан или слепки",
  "recipe.check.reference.arches": "Зубные дуги",
  "recipe.check.reference.correction_with_ct": "Коррекция с КТ или без",

  "Ляшук Даниил": "Ляшук Даниил",
  "Аптекарев Федор": "Аптекарев Федор",
  "Дмитриенко Ирина": "Дмитриенко Ирина",
  "Сосин Михаил": "Сосин Михаил",

  "notify.doctor.update.success": "Информация обновлена",
  "notify.doctor.update.error": "Пользователь с таким логином или email уже зарегистрирован",
  "notify.doctor.password.success": "Пароль успешно изменен",
  "notify.doctor.password.failed": "При изменении пароля произошла ошибка",
  "notify.comment": "Комментарий добавлен",
  "notify.comment.error": "При сохранении комментария произошла ошибка",
  "notify.question": "Вопрос отправлен Клиническому эксперту",
  "notify.question.error": "При отправлении вопроса возникла ошибка",

  "notify.patient.create.ok": "Новый пациент успешно создан",
  "notify.patient.create.draft.patient": "Ваш пациент ",
  "notify.patient.create.draft.ok": " был сохранен в черновиках, Вы можете продолжить заполнение рецепта во вкладке Пациенты",
  "notify.patient.submit.draft.error": "Черновик сохранён, отправка не удалась. Повторите попытку.",
  "notify.patient.create.error": "Ошибка создания пациента",
  "notify.patient.update.ok": "Пациент успешно изменен",
  "notify.patient.update.error": "Ошибка изменения пациента",

  "notify.add_clinic.ok": "Клиника добавлена",
  "notify.add_clinic.error": "При добавлении клиники произошла ошибка",

  "notify.unlink_clinic.ok": "Клиника удалена",
  "notify.unlink_clinic.error": "При удалении клиники произошла ошибка",

  "notify.correction.create.ok": "Коррекция создана",
  "notify.form.submitted.ok": "мы получили Ваш заказ\nи приступаем к работе над ним",
  "notify.correction.create.error": "При добавлении коррекции произошла ошибка",
  "notify.correction.thanks": "Спасибо что воспользовались новой формой заказа коррекции. Ждём ваши отзывы по адресу feedback@3d-smile.com",

  "notify.status_end.ok": "Статус пациента переведен на Лечение завершено",
  "notify.status_end.error": "При попытке завершить лечение произошла ошибка",

  "notify.retainers.ok": "Ретейнеры заказаны",
  "notify.retainers.error": "Ошибка заказа ретейнеров",
  "notify.power_cap.error": "Ошибка заказа силовой капы",

  "notify.additional.aligners.ok": "Дубликаты заказаны",
  "notify.additional.aligners.error": "При заказе дубликатов произошла ошибка",

  "notify.approve.ok": "План утвержден",
  "notify.approve.error": "При утверждении 3D плана произошла ошибка",

  "notify.rework.ok": "Благодарим за комментарии. Техники {labelTitle} уже работают над обновлениями 3D плана",
  "notify.rework.error": "При отправлении плана в работу произошла ошибка",

  "notify.doctor.subscribe": "Уведомления",
  "notify.doctor.subscribe.edit": "Подписка на уведомления",

  "notify.link_copy": "Ссылка скопирована в буфер обмена",
  "notify.link_tg": "Ссылка отправлена в Telegram",
  "notify.link_email": "Ссылка отправлена на email",
  "notify.link_tg_email": "Ссылка отправлена в Telegram и на email",

  "notify.send_password.EMAIL_SENT": "Одноразовый пароль отправлен на электронную почту",
  "notify.send_password.E_EMAIL_OR_LOGIN_REQUIRED": "Укажите адрес электронной почты или логин",
  "notify.send_password.E_EMAIL_NOT_FOUND": "Адрес электронной почты не найден",
  "notify.send_password.E_LOGIN_NOT_FOUND": "Логин не найден",
  "notify.send_password.SENDING_ERROR": "Ошибка при отправлении ссылки для восстановления. Проверьте введеные данные.",
  "notify.send_password.SENDING_RESTORE_SUCCESS": "Ссылка для восстановления пароля была отправлена на почту",

  "notify.login.SUCCESS": "SUCCESS",
  "notify.login.E_PASSWORD_RESET": "Необходимо задать новый пароль",
  "notify.login.E_INVALID_AUTH": "Неверный логин или пароль",

  "notify.meeting.reschedule.ok": "Встреча успешно перенесена",
  "notify.meeting.reschedule.error": "Произошла ошибки при переносе встречи",

  "notify.meeting.cancel.ok": "Встреча успешно отменена",
  "notify.meeting.cancel.error": "Произошла ошибки при отмене встречи",

  "notify.upload.E_UNSUPPORTED_FORMAT": "Формат файла, который вы загружаете, не поддерживается. Пожалуйста, загрузите файл в формате JPEG.",
  "notify.upload.E_UNSUPPORTED_FORMAT_EXT":
    "Формат файла, который вы\u00a0загружаете, не\u00a0поддерживается. Пожалуйста, загрузите файл в\u00a0одном из\u00a0следующих форматов: JPG, JPEG, PNG, STL, PDF, ORTHO, MP4.",
  "notify.upload.E_UNSUPPORTED_FORMAT_EXT_WITH_ARCHIVE":
    "Формат файла, который вы\u00a0загружаете, не\u00a0поддерживается. Пожалуйста, загрузите файл в\u00a0одном из\u00a0следующих форматов: JPG, JPEG, PNG, STL, PDF, ORTHO, MP4, ZIP, RAR.",
  "notify.upload.E_UNSUPPORTED_FORMAT_CBCT": "Формат файла, который вы\u00a0загружаете, не\u00a0поддерживается. Пожалуйста, загрузите архив в\u00a0формате ZIP или\u00a0RAR.",
  "notify.upload.E_FILE_TOO_BIG_CBCT": "Размер загружаемых файлов не должен превышать 1.5 Гб.",
  "notify.upload.E_PATIENT_FILE_TOO_BIG": "Размер загружаемых файлов не должен превышать {maxFileSizeMb} Мб.",
  "notify.patient.required_fields": "Заполните обязательные поля. Форма прокручена к\u00a0первому незаполненному полю.",

  "new_password.header": "Вы вошли с одноразовым паролем, пожалуйста задайте новый пароль.",
  "new_password.header_key": "Пожалуйста введите пароль, содержащий не менее 10 символов, латинские большие и маленькие буквы, цифры и специальные символы",
  "new_password.new_password": "Новый пароль",
  "new_password.confirm": "Подтверждение пароля",
  "new_password.button": "Сохранить",

  Privacy: "Политика конфиденциальности",

  nocorrection: "Рецепт указан в комментарии (см. выше)",
  correction: "Коррекция",
  "main.treatment": "Основное лечение",
  "correction.impressions": "Слепки",
  "correction.material": "Слепки",
  "correction.impressions.new": "Снимаю новые слепки / скан",
  "correction.impressions.old": "Без слепков (на основании последнего этапа)",
  "correction.reason": "Причина коррекции",
  "correction.failed.teeth": "На каких зубах движение не осуществилось",
  "correction.plan_type": "По какому плану продолжить лечение",
  "correction.old_plan": "Продолжить по предыдущему рецепту",
  "correction.new_plan": "Скорректировать рецепт",
  "correction.information_correct": "Информация введена верно",

  "correction.comment.title": "Заказ коррекции",
  "correction.comment.plan": "План:",
  "correction.comment.tooth": "Зуб",
  "correction.comment.stage": "Этап:",
  "correction.comment.arches.both": "Обе челюсти",
  "correction.comment.arches.upper": "Верхняя челюсть",
  "correction.comment.arches.lower": "Нижняя челюсть",
  "correction.comment.casts.new": "Будут подготовлены новые слепки",
  "correction.comment.casts.old": "Слепки на основании последнего этапа",
  "correction.comment.impressions.scan": "Будут подготовлены новые слепки (3D скан)",
  "correction.comment.impressions.impression": "Будут подготовлены новые слепки (слепки)",
  "correction.comment.movment_1": "Не соблюдался режим ношения кап",
  "correction.comment.movment_2": "Не осуществилось движение",
  "correction.comment.movment_type_0": "не выбрано движение",
  "correction.comment.movment_type_1": "интрузия",
  "correction.comment.movment_type_2": "экструзия",
  "correction.comment.movment_type_3": "ротация",
  "correction.comment.movment_type_4": "мезиализация",
  "correction.comment.movment_type_5": "дистализация",
  "correction.comment.movment_type_6": "торк",
  "correction.comment.movment_type_7": "тип (ангуляция)",
  "correction.comment.movment_type_8": "вестибулярное",
  "correction.comment.movment_type_9": "оральное",
  "correction.comment.correct_plan_1": "Продолжить лечение по предыдущему рецепту",
  "correction.comment.correct_plan_2": "Скорректировать рецепт",

  preferences: "Клинические предпочтения",
  "preferences.ipr": "Сепарация",
  "preferences.ipr_enabled": "Проводить сепарацию",
  "preferences.ipr_start_step": "Начинать сепарацию с этапа",
  "preferences.attachments": "Замки",
  "preferences.attachments_delay": "Установить замки на этапе",
  "preferences.attachments_deprecated_teeth": "Не устанавливать замки на отмеченных зубах",
  "preferences.expansion": "Расширение",
  "preferences.always_expand": "Всегда расширять",
  "preferences.incisor_relationship": "Соотношение резцов",
  "preferences.incisor_relationship.overjet": "Соотношение резцов по горизонтали, мм",
  "preferences.incisor_relationship.overbite": "Соотношение резцов по вертикали, мм",
  "preferences.upper_incisor_angulation": "Торк верхних резцов (укажите в градусах)",
  "preferences.additional_notes": "Дополнительно",
  "preferences.additional_notes.sub": "Дополнительные клинические предпочтения для большинства пациентов",
  "preferences.overcorrection": "Гиперкоррекция",
  "preferences.deep_bite_intrusion": "Интрузия при глубоком прикусе + 1 мм",
  "preferences.incisors_extrusion": "Экструзия резцов + 1 мм",
  "preferences.rotation_over_30dg": "Ротация более 30 градусов +5 градусов",
  "correction.exclusive.info.title": "Оплата коррекции",
  "correction.exclusive.info.text":
    "Коррекция по данному курсу является дополнительной услугой и оплачивается отдельно: 15 000 руб. — первый платёж (за изготовление 3D-плана коррекции); второй платёж за все каппы корректировочного плана рассчитывается индивидуально после согласования 3D-плана.",

  "comment.message.on.plan.approve": "Вы можете оставить комментарий по предоставленному 3D-плану в момент просмотра",

  "comment.on.3dplan.adjustment": "Комментарий к плану версии",
  COMMENT_TYPE_CE_QUESTION: "Вопрос клиническому эксперту",
  COMMENT_TYPE_CORRECTION: "Коррекционный рецепт",
  COMMENT_TYPE_REWORK: "Комментарий к плану",
  COMMENT_TYPE_REWORK_PRESICE: "Комментарий к плану / 3D Precise",
  COMMENT_TYPE_ORDER_RETAINERS: " ",

  "offer.header": "Оферта",
  "offer.accept": "Я прочитал и согласен с условиями",
  "offer.confirm_plan.btn": "Подписать",
  "offer.pdf_error": "Что-то пошло не так во время загрузки офферты",
  "notify.doctor.offer.error": "При утверждении оферты произошла ошибка",
  "notify.doctor.offer.success": "Договор оферты подписан",
  "page.footer.offer": "Оферта",

  "manuals.title": "Инструкции",
  "redesign.instructions.search": "Введите название...",
  "manuals.empty.query": "На вашем языке еще нет опубликованных инструкций.",

  "promo.title": "Промо-материалы",
  // Redesign promo heading; the legacy page uses `promo.title` above.
  "redesign.promo.title": "Материалы для пациентов",
  "promo.empty": "На вашем языке ещё нет опубликованных промо-материалов.",
  "promo.download": "Скачать",
  "manuals.loading": "Загрузка...",
  "notify.patient.payment_link.error": "При переходе на страницу оплаты произошла ошибка",
  "patient.area.payments.paid": "Оплата проведена успешно",
  "another.payer.person": "Укажите ФИО плательщика, если плательщиком не является сам пациент",
  PAYER_LAST_NAME: "Фамилия",
  PAYER_LAST_NAME_PLACEHOLDER: "Фамилия плательщика",
  PAYER_FIRST_NAME: "Имя",
  PAYER_FIRST_NAME_PLACEHOLDER: "Имя плательщика",
  PAYER_MIDDLE_NAME: "Отчество",
  PAYER_MIDDLE_NAME_PLACEHOLDER: "Отчество плательщика",

  E_LOGIN_REQUIRED: " ",
  EXTRA_SERVICE_OPTION_LAST_STAGE: "Капы по последнему этапу",
  EXTRA_SERVICE_OPTION_USE_SCAN: "Я буду использовать скан",
  EXTRA_SERVICE_OPTION_USE_IMPRESSIONS: "Я буду использовать слепки",

  //Doctor payments info
  "payments.account.delete.err": "При удалении данных произошла ошибка",
  "payments.doctor.total": "Итого к оплате:",

  //Additional Aligners Table
  "th.stage": "Этап",
  "th.amount": "Количество",
  "th.option": "Челюсть",
  "th.status": "Статус",
  "th.timestamp": "Дата заказа",

  // Additional Aligners
  "additional_aligners.patient.label": "Пациент",
  "additional_aligners.patient.placeholder": "Выберите пациента",
  "additional_aligners.patient.not_found": "Пациент не найден",
  "additional_aligners.patient.none": "Отсутствуют пациенты, для которых доступен заказ дубликатов кап",
  "additional_aligners.stage.description": "Перед выбором этапа, необходимо выбрать пациента",
  "additional_aligners.stage.delete": "Удалить этап",
  "additional_aligners.not_found": "Дубликаты кап не найдены",

  SCAN: "Скан файл",
  CAD: "CAD файл",
  CAM: "CAM файл",
  MILLING: "Milling файл",
  ATTACHED: "Прикрепленный файл",
  "patient.search.placeholder": "Введите фамилию, имя или ID пациента для поиска",

  "bonus.patient": "Бонусный пациент",
  "bonus.patients": "Бонусные пациенты",
  "bonus.patients.total": "Пациенты:",
  "bonus.patients.total.hint": "Пациенты, зачтённые в бонусную программу.",
  "bonus.period": "Бонусный период",
  "bonus.period.hint": "Период действия бонусной программы: пациенты, добавленные в этот срок, засчитываются для начисления бесплатных кейсов.",
  "bonus.all.cases": "Всего пациентов",
  "bonus.cases.left": "Добавлено",
  "bonus.cases.left.1": "из",
  "bonus.cases.left.2": "пациентов",
  "bonus.case.chosen": "Бонусный пациент выбран",
  "bonus.case.not.chosen": "Бонусный пациент не выбран",
  "bonus.patient.set.successfully": "Пациент отмечен как бонусный",
  "bonus.patient.set.error": "Ошибка при выборе бонусного пациента",
  "bonus.patient.btn": "Бонусный пациент",
  "bonus.patient.btn.confirm": "Выбрать бонусным",
  "bonus.patient.btn.description.1": "Вы уверены, что хотите выбрать пациента",
  "bonus.patient.btn.description.2": "бонусным",
  "bonus.period.end.days": "дней до конца бонусного периода",
  "bonus.period.end.months": "месяцев до конца бонусного периода",
  "bonus.patient.activation.one": "пациент до активации бонусного пациента",
  "bonus.patient.activation.more": "пациента до активации бонусного пациента",
  "bonus.patient.activation.a.lot": "пациентов до активации бонусного пациента",
  "bonus.full.coin.title": "Вы можете заказать бонусного пациента",
  "bonus.hint.available":
    "{count, plural, one {Бонусный пациент доступен к заказу.} few {Бонусных пациента доступно к заказу.} many {Бонусных пациентов доступно к заказу.} other {Бонусных пациента доступно к заказу.}}",
  "bonus.hint.until.activation":
    "{count, plural, one {Пациент до активации бонусного.} few {Пациента до активации бонусного.} many {Пациентов до активации бонусного.} other {Пациента до активации бонусного.}}",

  // bonuses page
  "bonuses.page.title": "Программа лояльности",
  "bonuses.page.active.bonuses": "Активные смайлы",
  "bonuses.page.non.active.bonuses": "Списанные бонусы",
  "bonuses.page.expert.description": "1 смайл дает 1 скайп с экспертом.",
  "bonuses.page.video.description": "Для оплаты смайлами сообщите менеджеру при регистрации на мероприятие.",
  "bonuses.page.choose.event": "Выбрать мероприятие",
  "bonuses.page.last.description": "Оплатить смайлами можно не более 50% стоимости мероприятия.  ",

  "geo.city": "Город",

  "login.error": "Неверный логин или пароль",
  "password.recovery.invalid.link": "Ссылка не является действительной",
  "password.recovery.title": "Восстановление пароля",

  "password.requirements.header": "Пожалуйста, введите пароль, который удовлетворяет требованиям",
  "password.requirements.digits": "содержит цифры",
  "password.requirements.upper.chars": "содержит прописные буквы латинского алфавита",
  "password.requirements.lower.chars": "содержит строчные буквы латинского алфавита ",
  "password.requirements.length": "длина не менее 10 символов",
  "password.requirements.special": "содержит специальные символы",
  "password.requirements.match": "введенные пароли совпадают",
  "password.requirements.similar": "не слишком похож на ваш логин",
  "public.plan.error": "При получении публичной ссылки произошла ошибка",

  "p.patient.correction.stages": "Этапов",

  "meetings.heading": "Консультации с клиническим экспертом",
  "meetings.new": "Новая встреча",
  "meetings.enrolled.title.upcoming": "Мои предстоящие встречи",
  "meetings.enrolled.title.finished": "Мои завершенные встречи",
  "meetings.enrolled.title.all": "Мои встречи",
  "meetings.tabs.new": "Новая запись",
  "meetings.tabs.upcoming": "Предстоящие",
  "meetings.tabs.finished": "Завершенные",
  "meetings.tabs.all": "Все",
  "meetings.calendar": "Календарь",
  "meetings.add_to_calendar": "Добавить {br}в календарь",
  "meetings.reschedule": "Перенести встречу",
  "meetings.cancel": "Отменить встречу",
  "meetings.cancel.heading": "Вы уверены, что хотите отменить встречу?",
  "meetings.cancel.description.expert": "<b>Клинический эксперт:</b> {expertName}",
  "meetings.cancel.description.datetime": "<b>Дата:</b> {date} в {time}",
  "meetings.cancel.reason": "Причина отмены",
  "meetings.reschedule.reason": "Причина переноса",
  "meetings.reschedule.heading": "Вы уверены, что хотите перенести встречу?",
  "meetings.enter.cancel.reason.placeholder": "Введите причину отмены",
  "meetings.enter.reschedule.reason.placeholder": "Введите причину переноса",
  "meetings.detail": "Описание встречи",
  "meetings.your_question": "Ваш вопрос",
  "meetings.expert_comment": "Комментарий эксперта",
  "meetings.datetime": "Дата и время",
  "meetings.expert_comment_default": "Здесь появится комментарий эксперта...",
  "meetings.join": "Подключиться",
  "meetings.expert": "Клинический эксперт",
  "meetings.not.found": "Расписание не найдено",
  "meetings.not.found.description": "Здесь будут отображаться доступные для записи клинические эксперты",
  "meetings.error": "Не удалось загрузить расписание",
  "meetings.title": "Консультации с клиническим экспертом",
  "meetings.book.title": "Новая запись",
  "meetings.detail.title": "Описание встречи",
  "meetings.detail.not_found": "Встреча не найдена",
  "meetings.detail.not_found.description": "К сожалению, мы не смогли найти эту встречу",
  "meetings.detail.error": "Не удалось загрузить встречу",
  "meetings.book.error": "Не удалось загрузить расписание эксперта",
  "meetings.book.submit_error": "Не удалось записаться на консультацию. Попробуйте ещё раз.",
  "meetings.zoom_pending": "Ссылка на конференцию создаётся. Обновите страницу через минуту.",
  "meetings.book.not_found": "Расписание не найдено",
  "meetings.book.not_found.description": "К сожалению, мы не смогли найти расписание для этого эксперта",
  "meetings.enrolled.error": "Не удалось загрузить встречи",
  "meetings.enrolled.none": "Встречи отсутствуют",
  "meetings.enrolled.upcoming.none": "Здесь будет отображаться Ваши предстоящие встречи с клиническими экспертами",
  "meetings.enrolled.finished.none": "Здесь будет отображаться Ваши завершенные встречи с клиническими экспертами",
  "meetings.enrolled.all.none": "Здесь будет отображаться все Ваши встречи с клиническими экспертами",
  "meetings.book": "Записаться",
  "meetings.book.short": "Записаться",
  "meetings.about_expert": "Об эксперте",
  "meetings.about_expert.dialog_description": "Информация об эксперте:",
  "meetings.about_expert.got_it": "Понятно",
  "meetings.about_expert.specializations": "По каким вопросам обращаться:",
  "meetings.about_expert.watch_video": "Смотреть видео",
  "meetings.nearest_slot": "Ближайшая доступная запись",
  "meetings.nearest_slot.empty": "Отсутствует",
  "meetings.feedback.ok": "Благодарим за обратную связь! Ваш отзыв отправлен",
  "meetings.feedback.title": "Отзыв о консультации",
  "meetings.feedback.comment": "Комментарий",
  "meetings.feedback.rating": "Оценка",
  "meetings.feedback.submit": "Отправить",
  "meetings.feedback.later": "Оставить позже",
  "meetings.feedback.description.1": "Уважаемый доктор",
  "meetings.feedback.description.2": "у Вас состоялась онлайн-встреча с клиническим экспертом 3D Smile",
  "meetings.feedback.description.p1": " по пациенту: ",
  "meetings.feedback.description.p2": " по пациентам: ",
  "meetings.feedback.description.3": "Пожалуйста, поделитесь обратной связью о предоставленной консультации, это поможет нам стать лучше для Вас.",
  "meetings.select_datetime": "Выберите дату и время",
  "meetings.step": "Шаг {current} из {total}",
  "meetings.enter_details": "Введите свои данные",
  "meetings.no_time_available": "Нет доступного времени для записи",
  "meetings.form.name": "ФИО врача",
  "meetings.form.name.required": "Введите ваше имя и фамилию",
  "meetings.form.phone": "Телефон",
  "meetings.form.phone.required": "Введите номер телефона",
  "meetings.form.phone.pattern": "Проверьте правильность введенного номера телефона",
  "meetings.form.email.required": "Введите ваш email",
  "meetings.form.email.pattern": "Введите email в правильном формате",
  "meetings.form.patient": "Пациент",
  "meetings.form.theme": "Тема",
  "meetings.form.theme.placeholder": "Выберите тему",
  "meetings.form.question": "Вопрос по пациенту",
  "meetings.form.required": "Это поле обязательно для заполнения",
  "meetings.form.add": "Добавить пациента",
  "meetings.form.remove": "Убрать пациента",
  "meetings.book.success.title": "Поздравляем! Запись прошла успешно.",
  "meetings.book.success.heading": "Поздравляем!{br} Запись прошла успешно.",
  "meetings.book.success.another_expert": "Записаться к другому эксперту",
  "meetings.book.success.upcoming": "Перейти к предстоящим записям",

  "support.sidebar.title": "Контакты службы технической поддержки",
  "chat.title": "Чат",
  "chat.support_banner.title": "Команда поддержки",
  "chat.support_banner.desc": "Мы на связи и будем рады помочь! Ответим на ваши вопросы в рабочее время: будни, 9:00–18:00 (по МСК)",
  "chat.mini.back": "Назад",
  "chat.thread_list.collapse": "Свернуть список чатов",
  "chat.thread_list.expand": "Развернуть список чатов",
  "chat.thread_list.all": "Все чаты",
  "chat.channel.express_support": "Клиническая экспресс-поддержка",
  "chat.channel.express_support.subtitle": "Руководитель отдела 3D-моделирования",
  "chat.channel.express_support.description": "Оценка клинического случая, выбор курса, составление рецепта и вопросы по 3D-плану.",
  "chat.channel.personal_technician": "3D-моделировщик",
  "chat.channel.personal_technician.subtitle": "3D-моделировщик",
  "chat.channel.personal_technician.description": "Корректировка 3D-плана под ваши цели и задачи напрямую с техником",
  "chat.channel.personal_manager": "Персональный менеджер",
  "chat.channel.personal_manager.subtitle": "Персональный менеджер",
  "chat.channel.personal_manager.description": "Сопровождение по организационным и коммерческим вопросам",
  "chat.channel.care_department": "Отдел заботы",
  "chat.channel.care_department.subtitle": "Сервис и документы",
  "chat.channel.care_department.description": "Помощь со счетами, закрывающими документами и статусами заказов",
  "chat.media": "Медиа",
  "chat.tab.messages": "Чат",
  "chat.files.title": "Файлы чата",
  "chat.files.count": "{count, plural, one {# файл} few {# файла} many {# файлов} other {# файлов}}",
  "chat.files": "Файлы",
  "chat.media.empty": "Нет файлов",
  "chat.message.placeholder": "Введите сообщение",
  "chat.open.full": "Открыть в полный экран",
  "chat.send": "Отправить",
  "chat.attach": "Прикрепить файл",
  "chat.drop.title": "Отправка файлов",
  "chat.drop.description.line1": "Перетащите фотографии и файлы сюда,",
  "chat.drop.description.line2": "чтобы прикрепить их к сообщению",
  "chat.image.preview.close": "Закрыть",
  "chat.image.preview.download": "Скачать",
  "chat.video.expand": "Открыть в окне",
  "chat.files.empty": "Файлов нет",
  "chat.upload.error": "Не удалось загрузить файл",
  "chat.search.placeholder": "Поиск...",
  "chat.thread.search.placeholder": "Поиск...",
  "chat.thread.search.clear": "Очистить поиск",
  "chat.thread.search.results": "{count, plural, =0 {Ничего не найдено} one {# результат} few {# результата} many {# результатов} other {# результата}}",
  "chat.thread.search.empty": "Ничего не найдено",
  "chat.unread_total": "{count, plural, one {# непрочитанное сообщение} few {# непрочитанных сообщения} many {# непрочитанных сообщений} other {# непрочитанных сообщений}}",
  "chat.support_team": "Команда поддержки",
  "chat.support_team.subtitle": "Мы на связи и будем рады помочь!",
  "chat.support_team.hours": "Ответим на ваши вопросы в рабочее время:",
  "chat.support_team.hours_schedule": "будни, 9:00–18:00 (по МСК)",
  "chat.readonly.no_assignee_notice":
    "Здесь сохранена история сообщений с личным техником, которая осуществлялась ранее.\nНа данный момент за вами не закреплён техник-моделировщик, поэтому отправка сообщений недоступна.",
  "chat.readonly.no_assignee_notice_manager":
    "Здесь сохранена история переписки с персональным менеджером, которая велась ранее.\nНа данный момент за вами не закреплён персональный менеджер, поэтому отправка сообщений недоступна.",
  "chat.thread.empty_preview": "Пока нет сообщений",
  "chat.thread.file_only": "Вложения",
  "support.page.header": "Служба технической поддержки",
  "support.page.contacts.header": "Контакты службы технической поддержки",
  "support.page.toll.free": " ",
  "support.page.operating.hours": " ",
  "support.page.onbording.btn": " ",
  "support.page.onbording.btn.tooltip": " ",
  "support.page.zoom.call.title": " ",

  "additional.aligners.both.comment": "(опция включает две капы - одна для верхней и одна для нижней зубных дуг)",

  events: "Мероприятия",
  "events.upcoming": "Расписание",
  "events.search": "Поиск..",
  "events.empty": "Мероприятий нет",
  "events.error": "Не удалось загрузить мероприятия",
  "events.upcoming.empty.heading": "Пока нет мероприятий",
  "events.upcoming.empty.description": "Здесь будут отображаться доступные к регистрации и покупке мероприятия",
  "events.enrolled": "Мои мероприятия",
  "events.enrolled.empty.heading": "Пока нет предстоящих или посещенных мероприятий",
  "events.enrolled.empty.description": "В этом разделе будут отображаться Ваши предстоящие и посещенные мероприятия",
  "events.enrolled.empty.link": "Перейти к расписанию",
  "events.recordings": "Медиатека",
  "events.recordings.empty.heading": "Пока нет видео",
  "events.recordings.empty.description": "Здесь будут отображаться приобретенные Вами записи мероприятий",
  "events.recordings.empty.link": "Перейти к расписанию",
  "events.search.placeholder": "Название",
  "events.filters": "Фильтры",
  "events.filters.reset": "Сбросить",
  "events.training_level.short": "Уровень",
  "events.all": "Все",
  "events.meeting_type": "Формат",
  "events.meeting_type.offline": "Очное",
  "events.meeting_type.online": "Онлайн",
  "events.meeting_type.recording": "Видео",
  "events.price": "Стоимость",
  "events.price.free": "Бесплатное",
  "events.price.paid": "Платное",
  "events.training_level": "Уровень подготовки",
  "events.training_level.0": "Начальный",
  "events.training_level.1": "Базовый",
  "events.training_level.2": "Продвинутый",
  "events.city": "Город",
  "events.not_found.heading": "Мероприятия не найдены",
  "events.not_found.description": "К сожалению, мы не смоги найти мероприятий по вашему поиску",
  "events.recording": "Видео",
  "events.currency": "руб.",
  "events.free": "Бесплатно",
  "events.action.pay": "Оплатить",
  "events.action.pay.error": "Что-то пошло не так во время получения ссылки для оплаты. " + "Попробуйте повторить попытку позже",
  "events.action.zoom_join": "Подключиться",
  "events.action.buy": "Купить",
  "events.action.get": "Получить",
  "events.action.signup": "Регистрация",
  "events.action.watch": "Смотреть",
  "events.action.feedback": "Оставить отзыв",
  "events.badge": "неоплаченных мероприятий",
  "events.video_available": "Доступно видео",
  "events.watch_modal.title": "Перейти на {service}?",
  "events.watch_modal.description": "Вы будете перенаправлены на {service} для просмотра видеозаписи",
  "events.watch_modal.open": "Перейти",
  "events.watch_modal.cancel": "Отмена",
  "events.zoom_modal.title": "Перейти в Zoom?",
  "events.zoom_modal.description": "Вы будете перенаправлены в Zoom для подключения к встрече",
  "events.error.heading": "Не удалось загрузить мероприятия",
  "events.error.description": "Что-то пошло не так. Попробуйте перезагрузить страницу или повторить попытку позже",
  "events.error.reset": "Повторить",
  "event.not.found": "Мероприятие не найдено",
  "events.rates.complimentary": "Бесплатное",
  "events.rates.price": "Стоимость",
  "events.rates.price.package": "Стоимость за цикл",
  "events.package.list": "Мероприятия, входящие в цикл",
  "events.payments.package.pay": "Оплатить цикл мероприятий",
  "events.enroll.success": "Вы успешно зарегистрированы на мероприятие",
  "events.enroll.error": "При попытке записи на мероприятие прозошла ошибка",
  "event.button.register": "Регистрация",
  "event.button.zoom_join": "Подключиться в Zoom",
  "event.payments": "Оплата",
  "event.payments.money": "Итоговая стоимость мероприятия",
  "event.payments.smiles": "Оплата смайлами",
  "event.start.datetime": "Дата и время",
  "event.payment.smiles.total": 'Количество "Смайлов" к списанию',
  "events.payments.link.error": "Произошла ошибка при попытке перехода на страницу оплаты",
  "event.registration.payment.status": "Статус",
  "event.registration.CREATED": "Заявка создана",
  "event.registration.PROCESSING": "Ожидание оплаты",
  "event.registration.PENDING": "Ожидание оплаты",
  "event.registration.DECLINED": "Ошибка при оплате",
  "event.registration.SUCCESS": "Оплачено",
  "event.registration.CANCELED": "Заявка отменена",
  "event.registration.enrolled": "Участвую",
  "event.meeting_link": "Ссылка для встречи",
  "events.leave.feedback": "Расскажите о ваших впечатлениях оставив отзыв о мероприятии",
  "events.send.feedback.error": "При отправлении отзыва произошла ошибка",
  "events.send.feedback.thanks": "Спасибо за оставленный отзыв",
  "events.send.feedback.success": "Ваш отзыв успешно отправлен. Спасибо за обратную связь!",
  "events.feedback.error": "Информация о мероприятии не найдена",
  "events.payment.legal_entity": "Наименование юридического лица",
  "events.payment.email": "Email",
  "events.payment.email.hint": "(Email адрес для направления договора)",
  "events.payment.email.doctor.hint": "(будет сохранен в Вашем профиле)",
  "events.payment.invoice.hint": "(для оплаты юридическим лицом)",
  "events.offer.sign": "Я прочитал и согласен",
  "events.registration.completed": "Нет мест",
  "events.registration.completed.verbose": "Не осталось свободных мест",
  "events.payment_status.goto": "Перейти к мероприятию",

  "toasts.yandex_metrika.text": "Мы используем файлы cookie для улучшения работы сайта.",
  "toasts.telegram.text": "Актуальные новости лаборатории, анонсы мероприятий в нашем Telegram-канале",
  "toasts.telegram.goto": "Перейти",

  // Agreements
  "agreement.title": "Дополнительное соглашение",
  "agreement.heading": "Дополнительное соглашение",
  "agreement.accept": "Подписать",
  "agreement.reject": "Отклонить",
  "agreement.download": "Скачать",
  "agreement.pdf_error": "Что-то пошло не так во время загрузки дополнительного соглашения",
  "agreement.notify.accept.success": "Дополнительное соглашение подписано",
  "agreement.notify.accept.error": "При подписании дополнительного соглашения произошла ошибка",
  "agreement.notify.reject.success": "Дополнительное соглашение отклонено",
  "agreement.notify.reject.error": "При отклонении дополнительного соглашения произошла ошибка",
  "agreements.table.error": "Не удалось загрузить документы",
  "agreements.table.not_found": "Документы не найдены",
  "agreements.table.title": "Название",
  "agreements.table.status": "Статус",
  "agreements.table.status.accepted": "Подписано",
  "agreements.table.status.rejected": "Отклонено",
  "agreements.table.status.pending": "Ожидание",
  "agreements.table.ends_at": "Действует до",

  // redesign-v1 (за флагом FEATURE_REDESIGN_V1)
  "redesign.common.not_set": "Не указано",
  "redesign.common.yes": "Да",
  "redesign.common.no": "Нет",
  "redesign.profile.title": "Мой профиль",
  "redesign.profile.edit": "Редакт.",
  "redesign.profile.edit_full": "Редактировать",
  "redesign.profile.add": "Добавить",
  "redesign.profile.add_clinic": "Добавить клинику",
  "redesign.profile.logout": "Выйти из профиля",
  "redesign.profile.section.info": "Информация о профиле",
  "redesign.profile.section.clinics": "Мои клиники",
  "redesign.profile.section.prefs": "Клинические предпочтения",
  "redesign.profile.clinics.empty": "Клиник пока нет.",
  "redesign.profile.field.login": "Логин",
  "redesign.profile.field.fio": "ФИО",
  "redesign.profile.field.last_name": "Фамилия",
  "redesign.profile.field.first_name": "Имя",
  "redesign.profile.field.middle_name": "Отчество",
  "redesign.profile.field.email": "E-mail",
  "redesign.profile.field.phone": "Телефон",
  "redesign.profile.field.telegram": "Telegram ID",
  "redesign.profile.field.notifications": "Уведомления",
  "redesign.profile.field.push": "Push",
  "redesign.profile.push.enable": "Включить push-уведомления",
  "redesign.profile.push.enabling": "Включаем…",
  "redesign.profile.push.enabled": "Push-уведомления включены",
  "redesign.profile.push.disable": "Отключить",
  "redesign.profile.push.error": "Не получилось включить push-уведомления",
  "redesign.profile.push.denied": "Уведомления заблокированы в браузере",
  "redesign.profile.push.denied_hint": "Откройте настройки сайта в браузере (или настройки уведомлений в системе) и разрешите уведомления для Док ЛК, затем обновите страницу.",
  "redesign.profile.push.stale": "Подписка устарела",
  "redesign.profile.push.stale_hint": "Похоже, подписка на уведомления перестала работать. Включите их заново.",
  "redesign.pwa.install.title.android": "Установите Док ЛК на телефон",
  "redesign.pwa.install.body.android": "Приложение будет открываться прямо с главного экрана — без браузера, быстрее и с push-уведомлениями о важных событиях.",
  "redesign.pwa.install.cta.android": "Установить",
  "redesign.pwa.install.title.ios": "Установите Док ЛК на iPhone",
  "redesign.pwa.install.body.ios": "Добавьте Док ЛК на главный экран — приложение будет открываться отдельно от браузера, с push-уведомлениями о важных событиях.",
  "redesign.pwa.install.step.ios.share": "Нажмите «Поделиться» в панели браузера",
  "redesign.pwa.install.step.ios.add": "Выберите «На экран «Домой»»",
  "redesign.pwa.install.cta.ios": "Понятно",
  "redesign.pwa.install.dismiss": "Не сейчас",
  "redesign.pwa.push_primer.title": "Включите уведомления",
  "redesign.pwa.push_primer.body": "Теперь Док ЛК умеет присылать push-уведомления — о новых сообщениях, оплатах, встречах и других важных событиях, даже когда приложение закрыто.",
  "redesign.pwa.push_primer.cta": "Включить",
  "redesign.pwa.push_primer.dismiss": "Не сейчас",
  "redesign.profile.field.clinic_name": "Название",
  "redesign.profile.field.clinic_address": "Адрес",
  "redesign.profile.pref.separation": "Сепарация",
  "redesign.profile.pref.attachments": "Замки",
  "redesign.profile.pref.expansion": "Расширение",
  "redesign.profile.pref.incisor_relationship": "Соотношение резцов",
  "redesign.profile.pref.deep_bite": "Интрузия при глубоком прикусе + 1 мм",
  "redesign.profile.pref.extrusion": "Экструзия резцов + 1 мм",
  "redesign.profile.pref.rotation": "Ротация более 30 градусов +5 градусов",
  "redesign.delivery.title": "Доставки",
  "redesign.delivery.description": "Здесь Вы можете отслеживать доставку элайнеров",
  "redesign.delivery.date_label": "Просмотреть с выбранной даты",
  "redesign.delivery.date_placeholder": "Выберите дату",
  "redesign.delivery.col.id": "ID",
  "redesign.delivery.col.patient": "ФИО пациента",
  "redesign.delivery.col.tracking": "Трекинг номер",
  "redesign.payments.col.status": "Статус",
  "redesign.payments.select_service": "Выбрать услугу",
  "redesign.payments.select_service_short": "Выбрать",
  "redesign.payments.total_label": "Итого к оплате",
  "redesign.delivery.loading": "Загрузка…",
  "redesign.delivery.empty": "Доставки не найдены.",
  "redesign.clinic.title": "Добавить клинику",
  "redesign.clinic.submit": "Добавить клинику",
  "redesign.clinic.section.admin": "Контакты по административным вопросам",
  "redesign.clinic.section.delivery": "Контакты по вопросам доставки",
  "redesign.clinic.schedule": "График работы",
  "redesign.clinic.schedule.from": "с",
  "redesign.clinic.schedule.to": "до",
  "redesign.clinic.field.name": "Название",
  "redesign.clinic.field.email": "Email клиники",
  "redesign.clinic.field.address": "Адрес",
  "redesign.clinic.field.building": "Дом",
  "redesign.clinic.field.city": "Город",
  "redesign.clinic.field.zip": "Почтовый индекс",
  "redesign.clinic.field.phone": "Номер телефона клиники",
  "redesign.clinic.field.contact": "С кем связываться по счетам и договорам",
  "redesign.clinic.field.logistic_phone": "Номер телефона для службы доставки (не более 15 символов)",
  "redesign.clinic.field.logistic_contact": "Контактное лицо для связи со службой доставки (не более 35 символов)",
  "redesign.clinic.ph.name": "Введите название",
  "redesign.clinic.ph.email": "Введите email",
  "redesign.clinic.ph.address": "Улица (не более 35 символов)",
  "redesign.clinic.ph.building": "Дом / строение / корпус (не более 35 символов)",
  "redesign.clinic.ph.city": "Город / страна (не более 35 символов)",
  "redesign.clinic.ph.zip": "Введите почтовый индекс",
  "redesign.clinic.ph.phone": "Введите номер клиники",
  "redesign.clinic.ph.contact": "Введите комментарий",
  "redesign.clinic.ph.logistic_phone": "Введите номер для службы доставки",
  "redesign.clinic.ph.logistic_contact": "Введите контактное лицо",
  "redesign.clinic.err.required": "Обязательное поле",
  "redesign.clinic.err.email": "Введите корректный email",
  "redesign.clinic.err.zip": "Введите корректный почтовый индекс",
  "redesign.clinic.err.phone": "Введите корректный номер телефона",
  "redesign.clinic.day.mon": "Понедельник",
  "redesign.clinic.day.tue": "Вторник",
  "redesign.clinic.day.wed": "Среда",
  "redesign.clinic.day.thu": "Четверг",
  "redesign.clinic.day.fri": "Пятница",
  "redesign.clinic.day.sat": "Суббота",
  "redesign.clinic.day.sun": "Воскресенье",
  "redesign.profile_edit.change_password": "Сменить пароль",
  "redesign.common.editing": "Редактирование",
  "redesign.clinic_view.title": "Информация о клинике",
  "redesign.clinic_view.field.clinic": "Клиника",
  "redesign.clinic_view.field.email": "E-mail клиники",
  "redesign.clinic_view.field.address": "Адрес клиники",
  "redesign.clinic_view.field.zip": "Почтовый индекс",
  "redesign.clinic_view.field.phone": "Номер телефона клиники",
  "redesign.clinic_view.field.contact": "Контактные данные",
  "redesign.clinic_view.field.logistic_phone": "Номер телефона для службы доставки",
  "redesign.clinic_view.field.logistic_contact": "Контактное лицо для связи со службой доставки",
  "redesign.clinic_view.schedule": "График работы",
  "redesign.prefs.title": "Клинические предпочтения",
  "redesign.prefs.submit": "Сохранить изменения",
  "redesign.prefs.err.int_range": "Введите целое число от 1 до 99",
  "redesign.prefs.err.float_min": "Значение должно быть не меньше 1.0",
  "redesign.prefs.separation": "Сепарация (проводить сепарацию)",
  "redesign.prefs.ipr_start": "Начинать сепарацию с этапа",
  "redesign.prefs.attachments": "Замки (установить замки на этапе)",
  "redesign.prefs.expansion": "Расширение (всегда расширять)",
  "redesign.prefs.incisors": "Соотношение резцов",
  "redesign.prefs.overjet": "Соотношение резцов по горизонтали, мм",
  "redesign.prefs.overbite": "Соотношение резцов по вертикали, мм",
  "redesign.prefs.stepper.up": "Увеличить значение",
  "redesign.prefs.stepper.down": "Уменьшить значение",
  "redesign.prefs.angulation": "Торк верхних резцов (укажите в градусах)",
  "redesign.prefs.overcorrection": "Гиперкоррекция",
  "redesign.prefs.deep_bite": "Интрузия при глубоком прикусе + 1 мм",
  "redesign.prefs.extrusion": "Экструзия резцов + 1 мм",
  "redesign.prefs.rotation": "Ротация более 30 градусов +5 градусов",
  "redesign.prefs.additional": "Дополнительно",
  "redesign.prefs.ph.value": "Введите значение",
  "redesign.prefs.ph.additional": "Дополнительные клинические предпочтения для большинства пациентов",
  "redesign.profile_edit.title": "Информация о профиле",
  "redesign.profile_edit.submit": "Сохранить изменения",
  "redesign.profile_edit.ph.email": "Введите email",
  "redesign.profile_edit.ph.phone": "Введите номер телефона",
  "redesign.profile_edit.ph.telegram": "Введите Telegram ID",
  "redesign.profile_edit.notify_telegram": "Telegram",
  "redesign.profile_edit.notify_email": "Email",
  "redesign.nav.achievements": "Мои достижения",
  "redesign.nav.patients": "Пациенты",
  "redesign.nav.payments": "Платежи",
  "redesign.nav.delivery": "Доставки",
  "redesign.nav.chat": "Чат",
  "redesign.nav.learning": "Мероприятия",
  "redesign.nav.consultations": "Консультации с экспертом",
  "redesign.nav.cases": "Клинические случаи",
  "redesign.nav.instructions": "Инструкции",
  "redesign.nav.documents": "Документы",
  "redesign.nav.materials": "Материалы для пациентов",
  "redesign.nav.more": "Меню",
  "redesign.shell.call": "Позвонить",
  "redesign.shell.phone_copied": "Номер скопирован",
  "redesign.shell.write": "Написать",
  "redesign.shell.logout": "Выйти",
  "redesign.shell.edit_profile": "Редактировать профиль",
  "redesign.shell.breadcrumbs": "Хлебные крошки",
  "redesign.shell.home": "Главная",
  "redesign.shell.patient": "Пациент {id}",
  // Хлебные крошки для legacy-страниц в оболочке редизайна.
  "redesign.shell.online_payment": "Он-лайн оплата",
  "redesign.shell.elite": "3D Smile Elite",

  "redesign.shell.all_deliveries": "Все отправления",
  "redesign.shell.event_detail": "Описание",
  "redesign.shell.scrollToTop": "Наверх",
  "redesign.patient_form.required_banner": "Поля, отмеченные <accent>*</accent>, обязательны для заполнения",
  "redesign.patient.form.ct.zip_hint": "Принимаются файлы в формате архива (.zip)",
  "redesign.patient.form.ct.link_placeholder": "Введите ссылку на КТ",
  "redesign.shell.manager": "Ваш менеджер",
  "redesign.shell.help.title": "Нужна помощь?",
  "redesign.shell.help.desc": "Поможем разобраться с вашим вопросом.",
  "redesign.shell.help.cta": "Задать вопрос",
  "redesign.shell.contacts": "Контакты: +7 (495) 211-44-54",
  "redesign.shell.copyright": "{year} © ООО «3Д Смайл»",
  "redesign.patient.delivery.header": "Отправка слепков",
  "redesign.consult.title": "Консультации с экспертом",
  "redesign.consult.tab.new": "Новая запись",
  "redesign.consult.tab.upcoming": "Предстоящие",
  "redesign.consult.tab.done": "Завершенные",
  "redesign.consult.tab.all": "Все",
  "redesign.consult.expertLabel": "Клинический эксперт",
  "redesign.consult.slot": "Ближайшая доступная запись: {when}",
  "redesign.consult.noSlot": "Ближайшая доступная запись: отсутствует",
  "redesign.consult.about": "Об эксперте",
  "redesign.consult.book": "Записаться",
  "redesign.consult.empty": "Пока ничего нет.",
  "redesign.consult.error": "Не удалось загрузить экспертов. Попробуйте ещё раз.",
  "redesign.shell.doctor": "Доктор",
  "redesign.patients.search": "Найти пациента...",
  "redesign.patients.search_placeholder": "Поиск...",
  "redesign.patients.payment_alert": "У вас есть неоплаченные этапы — проверьте платежи.",
  "redesign.patients.add": "Добавить пациента",
  "redesign.patients.col.patient": "Пациент",
  "redesign.patients.col.status": "Статус",
  "redesign.patients.status_filter.clear": "Сбросить",
  "redesign.back": "Назад",
  "redesign.pv.plan.title": "3D-план",
  "redesign.pv.plan.title.pending": "3D план на утверждение",
  "redesign.pv.plan.view": "Смотреть 3D План",
  "redesign.pv.card.title": "Карта пациента",
  "redesign.pv.card.edit": "Редактировать",
  "redesign.pv.payment.title": "Статус оплаты",
  "redesign.pv.main_treatment": "Основное лечение",
  "redesign.pv.comments.history": "История сообщений",
  "redesign.pv.comments.placeholder": "Введите комментарий",
  "redesign.patients.tab.all": "Все пациенты",
  "redesign.patients.tab.waiting": "Ждут действий",
  "redesign.patients.tab.working": "В работе",
  "redesign.patients.tab.drafts": "Черновики",
  "redesign.patients.tab.done": "Завершены",
  "redesign.patients.tab.canceled": "Не состоялись",
  "redesign.patients.prev": "Назад",
  "redesign.patients.next": "Далее",
  // The education card's online-format badge. Redesign-scoped because the frame says "Вебинар" where the
  // shared `events.meeting_type.online` says "Онлайн" — renaming that id would re-copy the legacy page.
  "redesign.education.format.online": "Вебинар",
  // Desktop uses "Введите название" while mobile uses the shared `events.search` message ("Поиск..").
  "redesign.education.search.desktop": "Введите название",
  // Placeholder for the redesign event feedback field.
  "redesign.event.feedback.placeholder": "Введите текст",
  "redesign.patients.pageOf": "{page} из {total}",
  "redesign.patients.first": "Первая страница",
  "redesign.patients.last": "Последняя страница",
  // — «Мои достижения» (dashboard, frames 7685-30220 / 7686-31581) —
  "redesign.dashboard.greeting.night": "Доброй ночи, {name}!",
  "redesign.dashboard.greeting.morning": "Доброе утро, {name}!",
  "redesign.dashboard.greeting.day": "Добрый день, {name}!",
  "redesign.dashboard.greeting.evening": "Добрый вечер, {name}!",
  "redesign.dashboard.tenure":
    "{years, plural, =0 {} one {# год} few {# года} many {# лет} other {# года}}{years, plural, =0 {} other { }}{months, plural, =0 {} one {и # месяц} few {и # месяца} many {и # месяцев} other {и # месяца}} вы создаёте клиническую историю вместе с 3D Smile.{br}Здесь собраны главные результаты этого пути.",
  "redesign.dashboard.tenure.unknown": "Здесь собраны главные результаты вашей работы вместе с 3D Smile.",
  "redesign.dashboard.orders.title": "Динамика заказов",
  "redesign.dashboard.orders.hint": "В статистику включены заказы за всю историю сотрудничества. Не учитываются пациенты со статусами «Недозаполненная заявка» и «Отказался от лечения».",
  "redesign.dashboard.orders.hint.year": "В статистику включены заказы за выбранный период. Не учитываются пациенты со статусами «Недозаполненная заявка» и «Отказался от лечения».",
  "redesign.dashboard.orders.patients":
    "{count, plural, one {Пациент за весь период работы} few {Пациента за весь период работы} many {Пациентов за весь период работы} other {Пациента за весь период работы}}",
  "redesign.dashboard.orders.active": "Активные заказы",
  "redesign.dashboard.orders.drafts": "Черновики",
  "redesign.dashboard.orders.other": "Другие курсы",
  "redesign.dashboard.course.unlimited": "Курс с КТ",
  "redesign.dashboard.course.oneJaw": "Одна челюсть",
  "redesign.dashboard.orders.percent": "{percent}%",
  "redesign.dashboard.year.prev": "Предыдущий год",
  "redesign.dashboard.year.next": "Следующий год",
  "redesign.dashboard.speed.title": "Скорость процессов и влияние на комплаенс",
  "redesign.dashboard.speed.hint": "Данные рассчитываются по календарным месяцам. Если выбран период «1 месяц», учитывается отрезок с 1-го числа текущего месяца по сегодняшний день.",
  "redesign.dashboard.period.1m": "1 мес",
  "redesign.dashboard.period.3m": "3 мес",
  "redesign.dashboard.period.6m": "6 мес",
  "redesign.dashboard.plan.versions": "Среднее количество версий 3D Плана",
  "redesign.dashboard.plan.approval": "Средний срок согласования 3D Плана",
  "redesign.dashboard.plan.patients": "Общее количество пациентов",
  // Retained for the backend `REFINEMENTS_METRIC` key, although the dashboard does not display it.
  "redesign.dashboard.plan.refinements": "Среднее количество коррекций",
  "redesign.dashboard.confidence.title": "Клиническая уверенность",
  "redesign.dashboard.confidence.hint": "В статистику включены консультации и мероприятия за всю историю сотрудничества. Учитываются только отмеченные как состоявшиеся.",
  "redesign.dashboard.engagement.consultations": "Количество завершенных консультаций",
  "redesign.dashboard.engagement.events": "Количество посещенных мероприятий",
  "redesign.dashboard.unit.versions": "{count, plural, one {версия} few {версии} many {версий} other {версии}}",
  "redesign.dashboard.unit.days": "{count, plural, one {день} few {дня} many {дней} other {дня}}",
  "redesign.dashboard.unit.patients": "{count, plural, one {пациент} few {пациента} many {пациентов} other {пациента}}",
  "redesign.dashboard.unit.refinements": "{count, plural, one {коррекция} few {коррекции} many {коррекций} other {коррекции}}",
  "redesign.dashboard.unit.consultations": "{count, plural, one {консультация} few {консультации} many {консультаций} other {консультации}}",
  "redesign.dashboard.unit.events": "{count, plural, one {мероприятие} few {мероприятия} many {мероприятий} other {мероприятия}}",
  "redesign.dashboard.engagement.booked": "из {booked} запланированных",
  "redesign.dashboard.no.data": "—",

  "maintenance.heading": "Уважаемый доктор! Личный кабинет временно недоступен",
  "viewer.refresh": "Обновить версии",
  "viewer.title": "3D-план v5",
  "viewer.open": "Открыть 3D-план v5",
  "viewer.versions": "Версии 3D-плана",
  "viewer.open.version": "Открыть",
  "viewer.watch": "Смотреть",
  "viewer.link": "Ссылка для пациента",
  "viewer.date": "Дата",
  "viewer.plan.name": "Название плана",
  "viewer.actions": "Действия",
  "viewer.status": "Статус",
  "viewer.available.since": "Доступен для согласования с {date}",
  "viewer.legacy.plan": "3D-план",
  "viewer.open.selected": "Открыть: {correction, select, 0 {основное лечение} other {коррекция {correction}}}, версия {version}",
  "viewer.archive": "Архив 3D-планов",
  "viewer.archive.count": "{count, plural, one {# версия} few {# версии} many {# версий} other {# версии}}",
  "viewer.archive.plans.count": "{count, plural, one {# план} few {# плана} many {# планов} other {# плана}}",
  "viewer.previous.plan": "Предыдущий план",
  "viewer.public.unavailable": "План по этой ссылке недоступен. Обратитесь к лечащему врачу.",
  "viewer.share.error": "Не удалось скопировать ссылку. Попробуйте ещё раз.",
  "viewer.share.selected": "Ссылка для пациента: {correction, select, 0 {основное лечение} other {коррекция {correction}}}, версия {version}",
  "viewer.report": "Отчёт",
  "viewer.report.selected": "Отчёт: {correction, select, 0 {основное лечение} other {коррекция {correction}}}, версия {version}",
  "viewer.report.unavailable": "Отчёт недоступен",
  "viewer.version": "Версия",
  "viewer.version.option": "{correction, select, 0 {Основное лечение} other {Коррекция {correction}}}, версия {version}",
  "viewer.state.draft": "Черновик",
  "viewer.state.pending": "На согласовании",
  "viewer.state.rework": "Отправлен на доработку",
  "viewer.state.approved": "Утверждён",
  "viewer.state.not_approved": "Не утверждён",
  "viewer.close": "Закрыть",
  "viewer.empty": "Нет доступных версий",
  "viewer.loading": "Загрузка…",
  "viewer.load.error": "Не удалось загрузить вьюер.",
  "viewer.list.error": "Не удалось получить версии 3D-плана.",
  "viewer.action.error": "Не удалось выполнить запрос. Попробуйте ещё раз.",
  "viewer.refresh.required": "Изменения сохранены. Обновите данные, чтобы продолжить.",
  "viewer.retry": "Повторить",
  "viewer.approve": "Утвердить план",
  "viewer.rework": "Вернуть на доработку",
  "viewer.consent": "Я ознакомился с условиями и согласен",
  "viewer.approve.profile.required": "Для утверждения должны быть заполнены имя врача и клиника пациента.",
  "viewer.remarks": "Комментарий к 3D-Плану",
  "viewer.comment.required": "Введите текст комментария.",
  "viewer.submit": "Отправить",
  "viewer.rework.submit": "Отправить на доработку",
  "viewer.cancel": "Отмена",
  "viewer.comments": "Комментарии к версии",
  "viewer.comments.error": "Не удалось загрузить комментарии.",
  "viewer.comments.empty": "Комментариев пока нет.",
  "viewer.comment": "Комментарий",
};

export default messages;
